/* eslint-disable no-lonely-if */
/* eslint-disable camelcase */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {
    useState,
    useMemo,
    useCallback,
    useEffect,
    useContext,
    useRef
} from 'react';
import { ViewModelServiceContext, ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';
import classNames from 'classnames';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useModal } from '@jutro/components';
import { FormattedMessage, useTranslator } from '@jutro/locale';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import moment from 'moment';
import { MLGafUtil, MLBillingUtil, MLNotificationBlockUtil, MLWizardNavUtil } from 'ml-portals-util-react';
import { MLFormUtil, MLProductCodeUtil } from 'ml-portals-util-js';
import { MLPaymentService, MLMultiLobsDataHolderService, MLPortalStorageService } from 'ml-services-common-react';
import { MLModalService } from 'ml-portals-services-react';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import { UserService } from 'gw-capability-gateway';
import { withRouter } from 'react-router-dom';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import {
    MLWizardPageActions,
    MLPaymentMethodComponent,
    MLPaymentScheduleComponent,
    MLRecurringPaymentComponent,
    MLDownPaymentComponent,
    MLBankAccountDetailsComponent,
    MLCreditCardDetailsComponent,
    MLEmployersAffiliationsComponent
} from 'ml-components-common-react';
import PATrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PATrackEvent';
import PUMBTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PUMBTrackEvent';
import HOTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/HOTrackEvent';
import metadata from './PaymentPage.metadata.json5';
import messages from './PaymentPage.messages';
import styles from './PaymentPage.module.scss';
import { Link } from '@jutro/router';


import { ScrollToError } from '@jutro/legacy/wizard-next';


// ==================== Constants (START) ==================== //
const ACCORDION_CARDS = {
    GROUP_DISCOUNT: 'groupDiscountCard',
    PAYMENT_METHOD: 'paymentMethodCard',
    PAYMENT_SCHEDULE: 'paymentScheduleCard',
    RECURRING_PAYMENT: 'recurringPaymentCard',
    DOWN_PAYMENT: 'downPaymentCard'
};

const BOA_BANK_NAME = 'boa';
const JPMC_BANK_NAME = 'jpmc';
const INSTALLMENT_SCHEDULE = 'installments';
const FULL_PAY_SCHEDULE = 'full_pay';
const ML_STORAGE_KEY_NEW_CREDIT_CARDS = 'NEW_CREDIT_CARDS';
const DOWNPAYMENT_INSTRUMENT_TYPE = 'downpayment';
const RECURRING_INSTRUMENT_TYPE = 'recurring';
const NON_PREFERRED_PAYMENT_METHODS = ['VISA', 'MC', 'AMEX', 'DISC'];

const {
    portalCode,
    MLRatingPaymentMethods,
    MLUserTypes,
    MLProducerTypes,
    MLAccountPaymentMethods,
    MLMinDaysToUseBankOpt,
    MLJpmcResponsePath,
    MLFormNumberWildcards,
    mercerOrganization
} = appConfig;

const {
    MLAnnuallyPayPlanPublicId,
    MLMortgageePayPlanPublicId,
    MLMonthlyPayPlanPublicId,
    MLTwicePerMonthPayPlanPublicId,
    MLMonthlyAnnualResponsivePlanPublicId,
    MLMonthlySemiAnnualResponsivePlanPublicId,
    MLTwoPayAnnualPlanPublicId,
    MLTwoPaySemiAnnualPlanPublicId,
    MLFourPayAnnualPlanPublicId,
    MLPayrollDeductPlanPublicId,
    FMPAMonthlyAnnualResponsivePlanPublicId,
    FMPAMonthlySemiAnnualResponsivePlanPublicId,
    NPTwoPayAnnualAutoPay
} = appConfig.mlPaymentPlan;

const {
    MLRatingForMonthlyPayrollDeductPayment
} = appConfig.mlRatingConfigs;
const isGPA = appConfig.portalCode === 'GPA';
const gpaMode = (portalCode === 'GPA');
const qnbMode = (portalCode === 'QB');

const _getUrlQueryParams = (url) => {
    const splitRst = url.split('?');
    const params = {};

    if (splitRst[1]) {
        let query = splitRst[1];
        query = query.split('+').join(' ');

        const re = /[?&]?([^=]+)=([^&]*)/g;
        let tokens = [];

        tokens = re.exec(query);
        while (tokens !== null && tokens.length > 2) {
            const key = decodeURIComponent(tokens[1]);
            const value = decodeURIComponent(tokens[2]);
            params[key] = value;
            tokens = re.exec(query);
        }
    }

    return params;
};

const _isPaymentPlanQuoted = (paymentPlan, paymentPlansQuoted, chosenQuoteData, firstYear = false) => {
    let paymentPlanQuoted = false;
    let foundPlan;
    const correctPlanId = firstYear ? MLMortgageePayPlanPublicId : MLAnnuallyPayPlanPublicId;
    if (paymentPlan.ratingPaymentMethod_ML === MLRatingPaymentMethods.MORTGAGEE) {
        foundPlan = paymentPlansQuoted.find((plan) => plan.ratingPaymentMethod_ML === paymentPlan.ratingPaymentMethod_ML
            && plan.ratingPaymentSchedule_ML === paymentPlan.ratingPaymentSchedule_ML
            && plan.branchCode === chosenQuoteData.branchCode
            && plan.paymentPlans_ML.find((pp) => pp.billingId === correctPlanId));
    } else if (chosenQuoteData.isCustom && paymentPlan.ratingPaymentMethod_ML === MLRatingPaymentMethods.MORTGAGEE) {
        foundPlan = paymentPlansQuoted.find((plan) => plan.ratingPaymentMethod_ML === paymentPlan.ratingPaymentMethod_ML
            && plan.ratingPaymentSchedule_ML === paymentPlan.ratingPaymentSchedule_ML
            && plan.branchCode === chosenQuoteData.branchCode && plan.isCustom
            && plan.paymentPlans_ML.find((pp) => pp.billingId === correctPlanId));
    } else if (chosenQuoteData.isCustom) {
        foundPlan = paymentPlansQuoted.find((plan) => plan.ratingPaymentMethod_ML === paymentPlan.ratingPaymentMethod_ML
            && plan.ratingPaymentSchedule_ML === paymentPlan.ratingPaymentSchedule_ML && plan.isCustom
            && plan.branchCode === chosenQuoteData.branchCode);
    } else {
        foundPlan = paymentPlansQuoted.find((plan) => plan.ratingPaymentMethod_ML === paymentPlan.ratingPaymentMethod_ML
            && plan.ratingPaymentSchedule_ML === paymentPlan.ratingPaymentSchedule_ML
            && plan.branchCode === chosenQuoteData.branchCode);
    }
    if (foundPlan) {
        paymentPlanQuoted = true;
    }
    return paymentPlanQuoted;
};

const _createPaymentPlanObject = (ratingPaymentMethod, ratingPaymentSchedule) => {
    return {
        ratingPaymentMethod_ML: ratingPaymentMethod,
        ratingPaymentSchedule_ML: ratingPaymentSchedule
    };
};

const _findQuoteDataForPaymentPlan = (baseOfferingQuote, paymentPlan, offeredQuotes, chosenQuote, firstYear = false) => {
    // check if quote exists with quoteBaseVersion_ML value (QB); for GPA check that branch code matches since quoteBaseVersion_ML is not used
    let quote;
    if (paymentPlan.ratingPaymentMethod_ML === MLRatingPaymentMethods.MORTGAGEE) {
        const correctPlanId = firstYear ? MLMortgageePayPlanPublicId : MLAnnuallyPayPlanPublicId;
        if (baseOfferingQuote.isCustom) {
            quote = offeredQuotes.find((offeredQuote) => offeredQuote.ratingPaymentMethod_ML === paymentPlan.ratingPaymentMethod_ML && offeredQuote.ratingPaymentSchedule_ML === paymentPlan.ratingPaymentSchedule_ML
                && offeredQuote.publicID === baseOfferingQuote.publicID
                && offeredQuote.paymentPlans_ML.find((pp) => pp.billingId === correctPlanId));
        } else {
            quote = offeredQuotes.find((offeredQuote) => offeredQuote.ratingPaymentMethod_ML === paymentPlan.ratingPaymentMethod_ML && offeredQuote.ratingPaymentSchedule_ML === paymentPlan.ratingPaymentSchedule_ML
                && offeredQuote.quoteBaseVersion_ML === baseOfferingQuote.publicID
                && offeredQuote.paymentPlans_ML.find((pp) => pp.billingId === correctPlanId));
        }
        if (!quote) {
            quote = offeredQuotes.find((offeredQuote) => offeredQuote.ratingPaymentMethod_ML === paymentPlan.ratingPaymentMethod_ML && offeredQuote.ratingPaymentSchedule_ML === paymentPlan.ratingPaymentSchedule_ML
                && offeredQuote.branchCode === baseOfferingQuote.branchCode
                && offeredQuote.paymentPlans_ML.find((pp) => pp.billingId === correctPlanId));
        }
    } else {
        if (baseOfferingQuote.isCustom) {
            quote = offeredQuotes.find((offeredQuote) => offeredQuote.ratingPaymentMethod_ML === paymentPlan.ratingPaymentMethod_ML && offeredQuote.ratingPaymentSchedule_ML === paymentPlan.ratingPaymentSchedule_ML
                && offeredQuote.publicID === baseOfferingQuote.publicID);
        } else {
            quote = offeredQuotes.find((offeredQuote) => offeredQuote.ratingPaymentMethod_ML === paymentPlan.ratingPaymentMethod_ML && offeredQuote.ratingPaymentSchedule_ML === paymentPlan.ratingPaymentSchedule_ML
                && offeredQuote.quoteBaseVersion_ML === baseOfferingQuote.publicID);
        }

        if (!quote) {
            quote = offeredQuotes.find((offeredQuote) => offeredQuote.ratingPaymentMethod_ML === paymentPlan.ratingPaymentMethod_ML && offeredQuote.ratingPaymentSchedule_ML === paymentPlan.ratingPaymentSchedule_ML
                && offeredQuote.branchCode === baseOfferingQuote.branchCode);
        }
    }
    return quote || null;
};

const PaymentPage = (props) => {
    const modalApi = useModal();
    const translator = useTranslator();
    const { wizardData, updateWizardData, goNext, isSkipping, steps, jumpTo, updateWizardSnapshot, history } = props;
    const { CustomQuoteService } = useDependencies('CustomQuoteService');
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { authHeader, authUserData } = useAuthentication();

    const viewModelService = useContext(ViewModelServiceContext);
    const submissionVM = useMemo(() => {
        return viewModelService.clone(wizardData);
    }, [viewModelService, wizardData]);

    const {
        onValidate,
        isComponentValid,
        registerComponentValidation
    } = useValidation('PaymentPage');

    const [showErrors, setShowErrors] = useState(false);

    const view = submissionVM.bindData;
    const gafInfo = submissionVM.baseData.gafInfo_ML;
    const [offeredQuotes] = useState(submissionVM.quoteData.offeredQuotes.value);

    const [referralValues, setReferralValues] = useState(submissionVM.bindData.ReferralAgents_ML);
    const [hasReferralAgentSelected, setHasReferralAgentSelected] = useState(submissionVM.bindData.hasReferralAgentSelected.value);
    const [isReferralAgentValid, setIsReferralAgentValid] = useState(true);
    const [selectedDownPaymentInstrument, setSelectedDownPaymentInstrument] = useState(new Map());
    const [showRecurringPaymentInstrumentError, setShowRecurringPaymentInstrumentError] = useState(false);
    const [showDownPaymentInstrumentError, setShowDownPaymentInstrumentError] = useState(false);
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const { refreshData } = useDataRefresh();

    const _isBankOptionValid = (periodStartDate) => {
        if (gpaMode) {
            return true;
        }
        const daysToEffectiveDate = moment().startOf('day').diff(periodStartDate, 'days');
        return daysToEffectiveDate < MLMinDaysToUseBankOpt;
    };

     useEffect(() => {
       if(qnbMode){
       _.set(submissionVM, 'bindData.paymentDetails.downPaymentMethod_ML.value', undefined);
       updateWizardData(submissionVM);
       }
     }, []);
    
    useEffect(() => {
        if (!qnbMode) return;
        const currentUrl = window.location.href;
        const blockId = 'block_' + new Date().getTime();
        window.history.pushState({ blockId }, '', currentUrl);
        const handlePopState = (event) => {
            if (!event.state || event.state.blockId !== blockId) {
                window.history.pushState({ blockId }, '', currentUrl);
                window.history.go(1);
            }
        };
        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [qnbMode]);
    
    const isBankOptAvailable = _isBankOptionValid(submissionVM.baseData.periodStartDate.value);

    const {
        getBaseOfferingQuote,
        getChosenQuoteDataFromQuotes,
        getFullPayPlanPeriodFromQuotes,
        getMortgageePlanPeriodFromQuotes,
        getInstallmentsPlanPeriodFromQuotes,
        getMonthlyPayrollDeductPlanPeriodFromQuotes,
        getPaymentMethodName,
        getPaymentChannels
    } = MLBillingUtil();

    const {
        validateGroupDiscountEligibility,
        validatePayrollDeductEligibility,
        shouldDeleteGafInfo,
        ELIG_STATUS
    } = MLGafUtil();

    const { nextStepVisited } = MLWizardNavUtil(props);

    const {
        showErrorModal,
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const {
        clearBlockAlerts,
        addWarningAlert,
        addErrorAlert,
        clearSpecificWarningAlert
    } = MLNotificationBlockUtil();

    const _shouldHideGAFAccordion = useCallback(() => {
        if(qnbMode) {
            return false;
        }

        const groupIndex = steps.findIndex((step) => step.mlStepName === 'paGroupAssociations' || step.mlStepName === 'hoGroupAssociations'
            || step.mlStepName === 'pupGroupAssociations');
        if (groupIndex === -1) {
            return true;
        }

        return gafInfo.gpcCode
            && gafInfo.gpcCode.value
            && validateGroupDiscountEligibility(gafInfo)
            && validatePayrollDeductEligibility(gafInfo);
    }, [gafInfo, validateGroupDiscountEligibility, validatePayrollDeductEligibility]);

    const [hideGAFAccordion, setHideGafAccorddion] = useState(_shouldHideGAFAccordion());

    const newBankAccountDetails = useCallback(() => {
        return viewModelService.create({ accountHolder: { value: {} } }, 'pc', 'metlife.edge.capabilities.policyjob.binding.dto.BankAccountDetailsDTOML');
    }, [viewModelService]);

    const [isVMInitialised, updateIsVMInitialised] = useState(false);
    const [currentCard, setCurrentCard] = useState('');
    const [currentUser, setCurrentUser] = useState({});
    const [paymentInstruments, setPaymentInstruments] = useState([]);
    const [paymentDetailsUrl, setPaymentDetailsUrl] = useState('');
    const [downPaymentDetailsUrl, setDownPaymentDetailsUrl] = useState('');
    const [showGroupDiscountSection, setShowGroupDiscountSection] = useState(() => { return qnbMode ? true : submissionVM.baseData.gafInfo_ML.gpcCode?.value !== undefined; });
    const [gafSectionShownInitially] = useState(() => { return showGroupDiscountSection; });
    const [gafRadioSelectionChanged, setGafRadioSelectionChanged] = useState(false);
    const [eligibilityInfoChanged, setEligibilityInfoChanged] = useState(false);
    const [isCitrixSecureEnv, setCitrixSecureEnv] = useState(false);
    const [chosenQuoteData, setChosenQuoteData] = useState(() => {
        return getChosenQuoteDataFromQuotes(offeredQuotes, view.chosenQuote.value);
    });
    const [offeredQuotesDownPaymentDetails_ML, setOfferedQuotesDownPaymentDetails_ML] = useState([]);
    const [selectedScheduleFromQuotePage, setSelectedScheduleFromQuotePage] = useState(() => { return chosenQuoteData.ratingPaymentSchedule_ML; });
    const [howPaymentWorks, setHowPaymentWorks] = useState(null);
    const [hasSsn, setHasSsn] = useState(false);
    const [hasDepartmentNumber, setHasDepartmentNumber] = useState(false);
    const [hasEmployeeNumber, setHasEmployeeNumber] = useState(false);
    const [hasMetroBadgeNumber, setHasMetroBadgeNumber] = useState(false);
    const [orgSelectedMortgagePay, setOrgSelectedMortgagePay] = useState(() => { return _.clone(view.paymentDetails.firstYear_ML.value); });
    const [newlyAddedCreditCards, setNewlyAddedCreditCards] = useState([]);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [usePaymentusAch, setUsePaymentusAch] = useState(false);
    const [disableNextButton, setDisableNextButton] = useState(false);
    const paymentChannelAvailableValues = view.paymentDetails.paymentChannel_ML.aspects.availableValues;
    const paymentChannels = getPaymentChannels();
    const paymentChannelOptions = useMemo(() => {
        return {
            agentInPerson: paymentChannelAvailableValues.find((value) => {
                return value.code === paymentChannels.AGENT_IN_PERSON;
            }),
            agentPhone: paymentChannelAvailableValues.find((value) => {
                return value.code === paymentChannels.AGENT_PHONE;
            }),
            customerPortal: paymentChannelAvailableValues.find((value) => {
                return value.code === paymentChannels.CUSTOMER_PORTAL;
            }),
            agentOnly: paymentChannelAvailableValues.find((value) => {
                return value.code === paymentChannels.AGENT;
            }),
            agencySweep: paymentChannelAvailableValues.find((value) => {
                return value.code === paymentChannels.AGENCY_SWEEP;
            }),
            customerService: paymentChannelAvailableValues.find((value) => {
                return value.code === paymentChannels.CUSTOMER_SERVICE;
            })
        };
    }, [paymentChannelAvailableValues, paymentChannels.AGENCY_SWEEP, paymentChannels.AGENT, paymentChannels.AGENT_IN_PERSON, paymentChannels.AGENT_PHONE, paymentChannels.CUSTOMER_PORTAL, paymentChannels.CUSTOMER_SERVICE]);

    const commissions = {
        valid: true
    };   

    const isGcsUser = useCallback(() => {
        return gpaMode && authUserData && (authUserData.userType === MLUserTypes.GCS_SALES || authUserData.userType === MLUserTypes.GCS_SERVICING);
    }, [authUserData]);

     const commissionOptions = {
        isSplitCommissionSelected: false,
        isReferralAgentSelected: hasReferralAgentSelected
    };

    const DL_ACTIONS = {
        ADD_ACOUNT: 'addAccount',
        CANCEL: 'cancel',
        EDIT_ACCOUNT: 'editAccount'
    };

    const setEligibilityInfoChangedAlert = () => {
        if (eligibilityInfoChanged) {
            addWarningAlert(messages.changingGroupEligibilityAffectPremium, 'changingPaymentMethodGroupEligibility');
        } else {
            clearBlockAlerts('changingPaymentMethodGroupEligibility');
        }
    };

    const _isValidPaymentInstrumentId = (instruments, id, type) => {
        if (!id) {
            return false;
        }
        const paymentInstrument = instruments.find((instrument) => instrument.token === id);
        return paymentInstrument && paymentInstrument.paymentMethod === type && (paymentInstrument.portalAvailable !== false || type === MLAccountPaymentMethods.CREDIT_CARD);
    };

    useEffect(() => {
        registerComponentValidation(() => submissionVM.aspects.valid && submissionVM.aspects.subtreeValid);
    }, [registerComponentValidation, submissionVM.aspects.subtreeValid, submissionVM.aspects.valid]);


    useEffect(() => {
        if (isGPA) {
            UserService.getCurrentUser(authHeader).then((user) => {
                if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                    HOTrackEvent('Issuance Step Reached', false, submissionVM, user, { step: 'Payment Page' });
                }
                else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                    PUMBTrackEvent('Issuance Step Reached', false, submissionVM, user, { step: 'Payment Page' });
                }
                else {
                    PATrackEvent('Issuance Step Reached', false, submissionVM, user, { step: 'Payment Page' });
                }
            });
        } else {
            if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                HOTrackEvent('Issuance Step Reached', false, submissionVM, null, { step: 'Payment Page' }, true);
            }
            else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                PUMBTrackEvent('Issuance Step Reached', false, submissionVM, null, { step: 'Payment Page' }, true);
            }
            else {
                PATrackEvent('Issuance Step Reached', false, submissionVM, null, { step: 'Payment Page' }, true);
            }

        }
    }, []);

    useEffect(() => {
        setEligibilityInfoChangedAlert();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eligibilityInfoChanged]);

    useEffect(() => {
        setTimeout(() => {
            const element = document.getElementById("printApplication");
            if (element) {
                element.focus();
            }
        }, 100)
    }, []);

    const _populatePaymentDetailsView = useCallback((bankAccountDetails) => {
        view.paymentDetails.sessionUUID_ML.value = submissionVM.sessionUUID.value;
        view.paymentDetails.quoteID_ML.value = submissionVM.quoteID.value;
        view.paymentDetails.bankAccountDetails_ML.value = bankAccountDetails.value;
        view.paymentDetails.isAddBankAccount_ML = true;
        view.paymentDetails.isPaymentChannelRequired_ML = false;
    }, [submissionVM.quoteID.value, submissionVM.sessionUUID.value, view.paymentDetails]);

    // special handling for Safari 
    const [safariFile, setSafariFile] = useState(undefined);
    const [safariFormNotReady, setSafariFormNotReady] = useState(false);
    const [safariFormError, setSafariFormError] = useState(false);
    const [printButtonMessage, setPrintButtonMessage] = useState('');

    const userAgentStringML = window.navigator.userAgent;
    const isSafariUser = userAgentStringML.match('^(?!.*(?:Chrome|Edge)).*Safari') != null;

    const _getFormToPrint = () => {
        return submissionVM.bindData.forms_ML.value.find((form) => (form.formNumber.startsWith(MLFormNumberWildcards.AUTO_APPLICATION_FORM)
            || form.formNumber.startsWith(MLFormNumberWildcards.HOME_APPLICATION_FORM)
            || form.formNumber.startsWith(MLFormNumberWildcards.UMBRELLA_APPLICATION_FORM)));
    };

    const safariLoadFormAtPageStart = () => {
        try {
            const formToPrint = _getFormToPrint();
            const getFormPromise = MLFormUtil.getFormData(formToPrint, submissionVM);

            if (typeof getFormPromise?.then === 'function') {
                getFormPromise.then((response) => {
                    try {
                        setSafariFile(new Blob([response], {
                            type: response.headers?.['content-type']
                        }));
                        setSafariFormError(false);
                        setPrintButtonMessage(translator(messages.PrintApplication));
                    } catch(e){
                        console.log("Safari Excp then function", e);
                        setSafariFormError(true);
                        setPrintButtonMessage(translator(messages.ApplicationUnavailable));
                    }
                }).catch((error) => {
                    console.log("Safari Excp then function, promise exception", error);
                    setSafariFormError(true);
                    setPrintButtonMessage(translator(messages.ApplicationUnavailable));
                });
            } else if (typeof getFormPromise?.success === 'function') {
                getFormPromise.success((response, status, responseHeaders) => {
                    try{
                        setSafariFile(new Blob([response], { type: responseHeaders('Content-Type') }));
                        setSafariFormError(false);
                        setPrintButtonMessage(translator(messages.PrintApplication));
                    } catch(err){
                        console.log("Safari Excp then function", err);
                        setSafariFormError(true);
                        setPrintButtonMessage(translator(messages.ApplicationUnavailable));
                    }
                }, (error) => {
                    console.log("Safari Excp success function, promise exception", error);
                    setSafariFormError(true);
                    setPrintButtonMessage(translator(messages.ApplicationUnavailable));
                });
            }
        } catch(ex) {
            console.log("Safari Excp Outer", ex);
            setSafariFormError(true);
            setPrintButtonMessage(translator(messages.ApplicationUnavailable));         
        }        
    };

    const _getPaymentusAchFlag = () => {
        MLPaymentService.usePaymentusACH(isGPA, authHeader).then((useAch) => {
            setUsePaymentusAch(useAch);
        });
    };

    useEffect(() => {
        if (!qnbMode && isSafariUser) {
            safariLoadFormAtPageStart();
        }
        _getPaymentusAchFlag();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Alert
    const onPaymentMethodChangedAlert = (newValue) => {
        clearBlockAlerts('changingPaymentMethod');
        if (newValue && !eligibilityInfoChanged) {
            addWarningAlert(messages.changingPaymentMethodAffectPremium, 'changingPaymentMethod');
        }
    };

    const onPreferredPaymentChangedAlert = (newValue) => {
        clearBlockAlerts('changingPreferredPayment');
        addWarningAlert(messages.preferredPaymentChangedAffectPremium, 'changingPreferredPayment');
    };

    const goToContactUs = () => {
        const contactUsPath = 'quote-and-buy/contact-us';
        const url = `${window.location.origin}/${contactUsPath}`;
        window.location.href = url;
    };

    const goToContactUsQnB = () => {
        const stateParams = {
            isQnBAndQuoted: true,
            quoteID: submissionVM.quoteID.value
        };
        history.push('/contact-us', stateParams);    
    };

    // ==================== Users (START) ==================== //
    const isPCSAgent = useCallback(() => {
        return gpaMode && authUserData && authUserData.userType === MLUserTypes.PCS;
    }, [authUserData]);

    const isIAAgent = useCallback(() => {
        return gpaMode && authUserData && authUserData.userType === MLUserTypes.IA;
    }, [authUserData]);

    const isMetGaUser = useCallback(() => {
        return gpaMode && authUserData && ((authUserData.userType === MLUserTypes.PCS && authUserData.primaryProducerCode_ML.producerType_ML === MLProducerTypes.IA)
            || authUserData.userType === MLUserTypes.MET_GA);
    }, [authUserData]);

    const isMercerUser = useCallback(() => {
        return gpaMode && authUserData?.primaryProducerCode_ML?.organization_ML.name?.toLowerCase()?.includes(mercerOrganization);
    }, [authUserData]);

    const isBankAccountPaymentMethod = useCallback((paymentMethod) => {
        return paymentMethod === MLAccountPaymentMethods.BANK_ACCOUNT || paymentMethod === MLRatingPaymentMethods.BANK_ACCOUNT;
    }, []);

    const isGcsSalesAgent = useCallback(() => {
        return gpaMode && authUserData && authUserData.userType === MLUserTypes.GCS_SALES;
    }, [authUserData]);

    const isGcsServiceAgent = useCallback(() => {
        return gpaMode && authUserData && authUserData.userType === MLUserTypes.GCS_SERVICING;
    }, [authUserData]);

    const isSplUser = useCallback(() => {
        return !isMercerUser() && (isGcsUser() || isMetGaUser());
    }, [isGcsUser, isMetGaUser, isMercerUser]);

    const isViewPrintButtonVisible = useCallback(() => {
        return gpaMode && (isPCSAgent() || isIAAgent() || isMetGaUser());
    }, [isPCSAgent, isIAAgent, isMetGaUser]);

    // ==================== Payment Account (START) ==================== //
    const hasPaymentInstrumentsForMethod = useCallback((method) => {
        return _.find(paymentInstruments, (paymentInstrument) => {                        
            return paymentInstrument.paymentMethod === method
                && (paymentInstrument.portalAvailable !== false || paymentInstrument.paymentMethod === MLAccountPaymentMethods.CREDIT_CARD);
        }) !== undefined;
    }, [paymentInstruments]);

    const _getNewlyAddedCreditCards = useCallback(() => {
        const retrievalPromise = MLPortalStorageService.retrieve(null, view.accountNumber.value, ML_STORAGE_KEY_NEW_CREDIT_CARDS, authHeader);
        retrievalPromise.then((response) => {
            if (response) {
                setNewlyAddedCreditCards(JSON.parse(response));
            } else {
                setNewlyAddedCreditCards([]);
            }
        }).catch(() => setNewlyAddedCreditCards([]));
    }, [newlyAddedCreditCards,authHeader]);

    const _storeNewlyAddedCreditCard = useCallback((id) => {
        if (!Array.isArray(newlyAddedCreditCards)) {
            setNewlyAddedCreditCards([]);
        }
        newlyAddedCreditCards.push({ token: id });
        // portal storage used to track credit cards that should be deleted after processing issuance payment
        MLPortalStorageService.store(null, view.accountNumber.value, ML_STORAGE_KEY_NEW_CREDIT_CARDS, JSON.stringify(newlyAddedCreditCards), authHeader);
    }, [newlyAddedCreditCards]);

    const _markCreditCardForDeletion = useCallback((id) => {
        MLPaymentService.markDownPaymentCardForDeletion(view.accountNumber.value, id, submissionVM.quoteID.value, gpaMode, submissionVM.sessionUUID.value, authHeader);
    }, [view.accountNumber.value, submissionVM.quoteID.value, submissionVM.sessionUUID.value, authHeader]);

    const setPaymentInstrument = useCallback((instrument) => {
        if (instrument) {
            if (instrument.paymentMethod === 'creditcard' || (usePaymentusAch && instrument.paymentMethod === 'ach')) {
                view.paymentDetails.nickname_ML.value = instrument.nickname ? instrument.nickname : instrument.accountType_ML;
                view.paymentDetails.last4Digits_ML.value = instrument.last4Digits;
                view.paymentDetails.creditCardExpDate_ML.value = instrument.creditCardExpDate;
            }
        }
    }, [usePaymentusAch, view.paymentDetails.creditCardExpDate_ML, view.paymentDetails.last4Digits_ML, view.paymentDetails.nickname_ML]);

    const setDownPaymentInstrument = useCallback((instrument) => {
        if (instrument) {
            if (instrument.paymentMethod === 'creditcard' || (usePaymentusAch && instrument.paymentMethod === 'ach')) {
                view.paymentDetails.downPaymentNickname_ML.value = instrument.nickname ? instrument.nickname : instrument.accountType_ML;
                view.paymentDetails.downPaymentLast4Digits_ML.value = instrument.last4Digits;
                view.paymentDetails.downPaymentCreditCardExpDate_ML.value = instrument.creditCardExpDate;

                setSelectedDownPaymentInstrument(selectedDownPaymentInstrument.set(view.paymentDetails.downPaymentMethod_ML.value, {
                    downPaymentNickname_ML: view.paymentDetails.downPaymentNickname_ML.value,
                    downPaymentLast4Digits_ML: view.paymentDetails.downPaymentLast4Digits_ML.value,
                    downPaymentCreditCardExpDate_ML: view.paymentDetails.downPaymentCreditCardExpDate_ML.value,
                    downPaymentInstrument_ML: view.paymentDetails.downPaymentInstrument_ML.value
                }));
            }
        }
    }, [selectedDownPaymentInstrument, usePaymentusAch, view.paymentDetails.downPaymentCreditCardExpDate_ML, view.paymentDetails.downPaymentInstrument_ML.value, view.paymentDetails.downPaymentLast4Digits_ML, view.paymentDetails.downPaymentMethod_ML.value, view.paymentDetails.downPaymentNickname_ML]);

    const isPaymentChannelAlreadySetByOtherUser = useCallback(() => {
        return (view.paymentDetails.paymentChannel_ML.value === paymentChannelOptions.agentPhone ||
            view.paymentDetails.paymentChannel_ML.value === paymentChannelOptions.agentInPerson);
    }, [view.paymentDetails.paymentChannel_ML.value, paymentChannelOptions]);

    const isShowAgentPaymentChannel = useCallback(() => {
        return (gpaMode && !hideDownPaymentSection() && (isPCSAgent() || isIAAgent()));
    }, [isIAAgent, isPCSAgent]);

    const setPaymentChannel = useCallback((aPaymentMethod) => {
        if (aPaymentMethod === undefined) {
            view.paymentDetails.paymentChannel_ML.value = undefined;
        } else if (!gpaMode) {
            view.paymentDetails.paymentChannel_ML = paymentChannelOptions.customerPortal;
        } else if (aPaymentMethod === 'agencysweep') {
            view.paymentDetails.paymentChannel_ML = paymentChannelOptions.agencySweep;
        } else if (isGcsServiceAgent()) {
            view.paymentDetails.paymentChannel_ML = paymentChannelOptions.customerService;
        } else if (aPaymentMethod === 'creditcard') {
            view.paymentDetails.paymentChannel_ML = paymentChannelOptions.agentOnly;
        } else if ((isGcsSalesAgent() || isMetGaUser()) && isBankAccountPaymentMethod(aPaymentMethod)) {
            view.paymentDetails.paymentChannel_ML = paymentChannelOptions.customerService;
        } else if (isShowAgentPaymentChannel() && isBankAccountPaymentMethod(aPaymentMethod)) {
            // clear payment channel as field will be displayed on screen for this
            view.paymentDetails.paymentChannel_ML.value = undefined;
        } else if (!isShowAgentPaymentChannel() && isBankAccountPaymentMethod(aPaymentMethod)) {
            if (!isPaymentChannelAlreadySetByOtherUser()) {
                view.paymentDetails.paymentChannel_ML = paymentChannelOptions.customerService;
            }
        } else {
            view.paymentDetails.paymentChannel_ML = paymentChannelOptions.customerService;
        }
    }, [isBankAccountPaymentMethod, isGcsSalesAgent, isGcsServiceAgent, isMetGaUser, isPaymentChannelAlreadySetByOtherUser, isShowAgentPaymentChannel, paymentChannelOptions.agencySweep, paymentChannelOptions.agentOnly, paymentChannelOptions.agentPhone, paymentChannelOptions.customerPortal, paymentChannelOptions.customerService, view.paymentDetails]);

    useEffect(() => {
        if (view.paymentDetails.downPaymentMethod_ML.value) {
            setPaymentChannel(view.paymentDetails.downPaymentMethod_ML.value);
            refreshData();
        }
    }, [view.paymentDetails.downPaymentMethod_ML.value]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (view?.paymentDetails?.selectedPaymentInstrument_ML?.value) {
            setPaymentChannel(view?.paymentDetails?.selectedPaymentInstrument_ML?.value);
            refreshData();
        }
    }, [view?.paymentDetails?.selectedPaymentInstrument_ML?.value]); // eslint-disable-line react-hooks/exhaustive-deps

    const setDownPaymentInstrumentById = useCallback((instruments, instrumentId) => {
        const paymentInstrument = instruments.find((instrument) => instrument.token === instrumentId);
        if (!_.isUndefined(paymentInstrument)) {
            view.paymentDetails.downPaymentInstrument_ML.value = instrumentId;
            setDownPaymentInstrument(paymentInstrument);
        } else {
            view.paymentDetails.downPaymentInstrument_ML.value = null;
        }
        setPaymentChannel(view.paymentDetails.downPaymentMethod_ML.value);
        if (qnbMode) {
            updateWizardData(submissionVM);
        }
        refreshData();
    }, [refreshData, setDownPaymentInstrument, setPaymentChannel, view.paymentDetails.downPaymentInstrument_ML, view.paymentDetails.downPaymentMethod_ML.value, submissionVM, updateWizardData, qnbMode]);

    const setRecurringPaymentInstrumentById = useCallback((instruments, instrumentId) => {
        const paymentInstrument = instruments.find((instrument) => instrument.token === instrumentId);
        if (!_.isUndefined(paymentInstrument)) {
            view.paymentDetails.selectedPaymentInstrument_ML.value = instrumentId;
            setPaymentInstrument(paymentInstrument);
        } else {
            view.paymentDetails.selectedPaymentInstrument_ML.value = null;
        }
        
        if(paymentInstrument?.paymentMethod){
            setPaymentChannel(paymentInstrument?.paymentMethod);
        }
        if (qnbMode) {
            updateWizardData(submissionVM);
        }
        refreshData();
    }, [refreshData, setPaymentInstrument, setPaymentChannel, view.paymentDetails.selectedPaymentInstrument_ML, submissionVM, updateWizardData, qnbMode]);

    const resetDownPaymentInstrument = useCallback(() => {
        view.paymentDetails.downPaymentNickname_ML.value = null;
        view.paymentDetails.downPaymentLast4Digits_ML.value = null;
        view.paymentDetails.downPaymentCreditCardExpDate_ML.value = null;
        view.paymentDetails.downPaymentInstrument_ML.value = null;
    }, [view.paymentDetails.downPaymentCreditCardExpDate_ML, view.paymentDetails.downPaymentInstrument_ML, view.paymentDetails.downPaymentLast4Digits_ML, view.paymentDetails.downPaymentNickname_ML]);

    const resetRecurringPaymentInstrument = useCallback(() => {
        view.paymentDetails.nickname_ML.value = null;
        view.paymentDetails.last4Digits_ML.value = null;
        view.paymentDetails.creditCardExpDate_ML.value = null;
        view.paymentDetails.selectedPaymentInstrument_ML.value = null;
    }, [view.paymentDetails.creditCardExpDate_ML, view.paymentDetails.selectedPaymentInstrument_ML, view.paymentDetails.last4Digits_ML, view.paymentDetails.nickname_ML]);

    // ==================== JPMC Integration (START) ==================== //

    const refreshPaymentInstruments = useCallback(() => {

        const promiseForJpmcPayInsts = MLPaymentService.getPaymentInstruments(
            submissionVM.sessionUUID.value,
            submissionVM.quoteID.value,
            view.accountNumber.value,
            gpaMode,
            authHeader
        );
        showProgressDialog(platformMessages.loading, promiseForJpmcPayInsts);
        return promiseForJpmcPayInsts.finally(() => {
            hideProgressDialog(platformMessages.loading);
        });
    }, [submissionVM.quoteID.value, submissionVM.sessionUUID.value, view.accountNumber.value, authHeader, showProgressDialog]);

    const refreshAccountList = useCallback(() => {
        const refreshPromise = refreshPaymentInstruments();
        refreshPromise.then((pms) => {
            setPaymentInstruments(pms);
        });
        return refreshPromise;
    }, [refreshPaymentInstruments, isSplUser]);


    const saveReferralAgentProducer = useCallback((referralAgents) => {
        setReferralValues(referralAgents);
        submissionVM.bindData.ReferralAgents_ML = referralAgents;
        _.set(submissionVM, 'bindData.referralAgents_ML', referralAgents);
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    const getType = () => {
        return currentCard === ACCORDION_CARDS.RECURRING_PAYMENT ? RECURRING_INSTRUMENT_TYPE : DOWNPAYMENT_INSTRUMENT_TYPE;
    };

    // ==================== Helper (START) ==================== //
    const getRatingPaymentMethodCode = useCallback(() => {
        return view.paymentDetails.ratingPaymentMethod_ML.value ? view.paymentDetails.ratingPaymentMethod_ML.value.code : '';
    }, [view.paymentDetails.ratingPaymentMethod_ML.value]);

    const allowAlternatePayor = useCallback(() => {
        return getRatingPaymentMethodCode() === MLRatingPaymentMethods.CREDIT_CARD || getRatingPaymentMethodCode() === MLRatingPaymentMethods.BANK_ACCOUNT;
    }, [getRatingPaymentMethodCode]);

    // ==================== Flags (START) ==================== //
    const isMortgageeSelected = useCallback(() => {
        return getRatingPaymentMethodCode() === MLRatingPaymentMethods.MORTGAGEE;
    }, [getRatingPaymentMethodCode]);

    const hasMortgageesOnSubmission = useCallback(() => {
        const { productCode } = submissionVM.baseData;
        if (MLProductCodeUtil.isHomeOwners(productCode.value) && submissionVM.lobData.homeowners.coverables.additionalInterests) {
            return _.find(submissionVM.lobData.homeowners.coverables.additionalInterests.value, { type: 'FIRSTMORTGAGEE' }) !== undefined;
        }
        return false;
    }, [submissionVM.baseData, submissionVM.lobData.homeowners]);

    const isPayByMortgageFirstYear = useCallback(() => {
        return getRatingPaymentMethodCode() === MLRatingPaymentMethods.MORTGAGEE && view.paymentDetails.firstYear_ML.value === true;
    }, [getRatingPaymentMethodCode, view.paymentDetails.firstYear_ML.value]);

    const isPayByMortgageSecondYear = useCallback(() => {
        return getRatingPaymentMethodCode() === MLRatingPaymentMethods.MORTGAGEE && view.paymentDetails.firstYear_ML.value === false;
    }, [getRatingPaymentMethodCode, view.paymentDetails.firstYear_ML.value]);

    const isMortgageePartyMissing = useCallback(() => {
        return getRatingPaymentMethodCode() === MLRatingPaymentMethods.MORTGAGEE && !hasMortgageesOnSubmission();
    }, [getRatingPaymentMethodCode, hasMortgageesOnSubmission]);

    const isCreditDebitSelected = useCallback(() => {
        return getRatingPaymentMethodCode() === MLRatingPaymentMethods.CREDIT_CARD;
    }, [getRatingPaymentMethodCode]);

    const isPayOnlineOrMailSelected = useCallback(() => {
        return getRatingPaymentMethodCode() === MLRatingPaymentMethods.PAY_ONLINE_OR_BY_MAIL;
    }, [getRatingPaymentMethodCode]);

    const isPayrollDeductionSelected = useCallback(() => {
        return getRatingPaymentMethodCode() === MLRatingPaymentMethods.PAYROLL_DEDUCT;
    }, [getRatingPaymentMethodCode]);

    const isBankAccountSelected = useCallback(() => {
        return getRatingPaymentMethodCode() === MLRatingPaymentMethods.BANK_ACCOUNT;
    }, [getRatingPaymentMethodCode]);

    const saveNewBankAccountPaymentInstrument = useCallback((bankAccountDetails, instrumentType) => {
        _populatePaymentDetailsView(bankAccountDetails);

        const promiseForBankAccount = MLPaymentService.addBankAccountPaymentInstrumentBySubmission(
            view.paymentDetails.value,
            gpaMode,
            authHeader
        );
        showProgressDialog(platformMessages.loading, promiseForBankAccount);

        promiseForBankAccount.then((newInstrumentId) => {
            refreshAccountList().then((pms) => {
                setPaymentInstruments(pms);
                if (instrumentType === RECURRING_INSTRUMENT_TYPE) {
                    setRecurringPaymentInstrumentById(pms, newInstrumentId);
                } else if (instrumentType === DOWNPAYMENT_INSTRUMENT_TYPE) {
                    setDownPaymentInstrumentById(pms, newInstrumentId);
                }
                refreshData();
            });
        })
            .catch((error) => goToContactUs(error, submissionVM))
            .finally(() => {
                view.paymentDetails.isAddBankAccount_ML = false;
            });
    }, [_populatePaymentDetailsView, view.paymentDetails, authHeader, showProgressDialog, refreshAccountList, refreshData, setRecurringPaymentInstrumentById, setDownPaymentInstrumentById, submissionVM]);

    const _getFirstPaymentInstrumentId = (instruments, type) => {
        const filteredInstruments = instruments.filter((instrument) => instrument.paymentMethod === type && (instrument.portalAvailable !== false || type === MLAccountPaymentMethods.CREDIT_CARD))
            .sort((a, b) => {
                return a.last4Digits - b.last4Digits;
            });
        if (filteredInstruments.length > 0) {
            return filteredInstruments[0].token;
        }
        return null;
    };

    const _getFirstPreferredPaymentInstrumentId = (instruments, type) => {
        const filteredInstruments = instruments.filter((instrument) => instrument.paymentMethod === type && (instrument.portalAvailable !== false || type === MLAccountPaymentMethods.CREDIT_CARD))
            .sort((a, b) => {
                return a.last4Digits - b.last4Digits;
            });

        let instrumentToken = null;
        filteredInstruments.forEach((instrument) => {
            if (instrumentToken === null && !NON_PREFERRED_PAYMENT_METHODS.includes(instrument.accountType_ML)) {
                instrumentToken = instrument.token;
            }
        })
        return instrumentToken;
    };

    const _defaultPaymentInstrument = useCallback((instruments, type, onDownPaymentMethodChange) => {
        if (type === undefined) {
            type = getType();
        }
        if (type === RECURRING_INSTRUMENT_TYPE) {
            if (isBankAccountSelected()) {
                const id = _getFirstPaymentInstrumentId(instruments, view.paymentDetails.paymentMethod.value);
                setRecurringPaymentInstrumentById(instruments, id);
            } else if (isCreditDebitSelected()) {
                if (isModernProduct && view.paymentDetails.preferredPaymentMethodInd_Ext.value) {
                    const id = _getFirstPreferredPaymentInstrumentId(instruments, view.paymentDetails.paymentMethod.value);
                    setRecurringPaymentInstrumentById(instruments, id);
                } else {
                    const id = _getFirstPaymentInstrumentId(instruments, view.paymentDetails.paymentMethod.value);
                    setRecurringPaymentInstrumentById(instruments, id);
                }
            }
        } else if (type === DOWNPAYMENT_INSTRUMENT_TYPE) {
            if (onDownPaymentMethodChange) {
                const id = _getFirstPaymentInstrumentId(instruments, view.paymentDetails.downPaymentMethod_ML.value);
                setDownPaymentInstrumentById(instruments, id);
            } else if ((isBankAccountSelected() && isBankOptAvailable) || isCreditDebitSelected()) {
                view.paymentDetails.downPaymentMethod_ML.value = view.paymentDetails.paymentMethod.value;
                setDownPaymentInstrumentById(instruments, view.paymentDetails.selectedPaymentInstrument_ML.value);
            } else if (view.paymentDetails.downPaymentMethod_ML.value) {
                const id = _getFirstPaymentInstrumentId(instruments, view.paymentDetails.downPaymentMethod_ML.value);
                setDownPaymentInstrumentById(instruments, id);
            } else {
                view.paymentDetails.downPaymentInstrument_ML.value = undefined;
            }
            setPaymentChannel(view.paymentDetails.downPaymentMethod_ML.value);
        }
        refreshData();
    }, [getType, isBankAccountSelected, isBankOptAvailable, isCreditDebitSelected, setDownPaymentInstrumentById, setPaymentChannel, setRecurringPaymentInstrumentById, view.paymentDetails.downPaymentInstrument_ML, view.paymentDetails.downPaymentMethod_ML, view.paymentDetails.paymentMethod.value, view.paymentDetails.selectedPaymentInstrument_ML.value, refreshData]);

    const setDownPaymentMethod = useCallback((value) => {
        if (value === 'ach') {
            setShowDownPaymentInstrumentError(false);
        }

        view.paymentDetails.downPaymentMethod_ML.value = value;
        resetDownPaymentInstrument();

        // Select previously selected instrument by default for the down payment method if available
        const prevSelectedInstrument = selectedDownPaymentInstrument.get(value);
        if (prevSelectedInstrument) {
            view.paymentDetails.downPaymentNickname_ML.value = prevSelectedInstrument.downPaymentNickname_ML;
            view.paymentDetails.downPaymentLast4Digits_ML.value = prevSelectedInstrument.downPaymentLast4Digits_ML;
            view.paymentDetails.downPaymentCreditCardExpDate_ML.value = prevSelectedInstrument.downPaymentCreditCardExpDate_ML;
            view.paymentDetails.downPaymentInstrument_ML.value = prevSelectedInstrument.downPaymentInstrument_ML;
        } else {
            const hasPaymentInstruments = hasPaymentInstrumentsForMethod(value);
            if (hasPaymentInstruments) {
                _defaultPaymentInstrument(paymentInstruments, DOWNPAYMENT_INSTRUMENT_TYPE, true);
            }
        }
        refreshData();
    }, [_defaultPaymentInstrument, hasPaymentInstrumentsForMethod, paymentInstruments, refreshData, resetDownPaymentInstrument, selectedDownPaymentInstrument, view.paymentDetails.downPaymentCreditCardExpDate_ML, view.paymentDetails.downPaymentInstrument_ML, view.paymentDetails.downPaymentLast4Digits_ML, view.paymentDetails.downPaymentMethod_ML, view.paymentDetails.downPaymentNickname_ML]);



    const _addPaymentusPaymentInstrument = useCallback((card, paymentMethodType) => {
        let saveFlag = { current: false };
        const updateSaveFlag = (val) => {
            saveFlag.current = val;
        };

        if (paymentMethodType === MLAccountPaymentMethods.CREDIT_CARD) {
            view.paymentDetails.bankName_ML = JPMC_BANK_NAME;
        } else {
            view.paymentDetails.bankName_ML = BOA_BANK_NAME;
        }
        const promiseForJpmcUrl = MLPaymentService.addPaymentInstrument(
            submissionVM.sessionUUID.value,
            submissionVM.quoteID.value,
            paymentMethodType,
            view.paymentDetails.preferredPaymentMethodInd_Ext.value,
            `${window.location.protocol}//${window.location.host}${MLJpmcResponsePath}`,
            view.accountNumber.value,
            gpaMode,
            isSplUser(),
            authHeader
        );

        showProgressDialog(platformMessages.loading, promiseForJpmcUrl);
        const paymentusIframeRecurringSameAsDownPayment_Ext = submissionVM.bindData.paymentDetails?.paymentusIframeRecurringSameAsDownPayment_Ext?.value ?? false;
        promiseForJpmcUrl.then((iframeUrl) => {
            const isRecurringFirstTime = card === ACCORDION_CARDS.RECURRING_PAYMENT && !isSplUser() && !hasPaymentInstrumentsForMethod(paymentMethodType)
            if (isRecurringFirstTime && !paymentusIframeRecurringSameAsDownPayment_Ext) {
                setPaymentDetailsUrl(iframeUrl)
            } else {
                const instrumentType = card === ACCORDION_CARDS.DOWN_PAYMENT ? DOWNPAYMENT_INSTRUMENT_TYPE : RECURRING_INSTRUMENT_TYPE;
                const existingPaymentInstrumentList = paymentInstruments.filter((instrument) => instrument.paymentMethod === paymentMethodType).map((instr) => instr.token);
                const componentProps = {
                    title: translator(messages.AddAccount),
                    CustomComponent: MLCreditCardDetailsComponent,
                    overrideProps: {
                        jpmcURL: iframeUrl,
                        gpaMode: gpaMode,
                        iframeHeight: '600px',
                        iframeWidth: '700px',
                        instrumentType: instrumentType,
                        isDownPaymentInstrument: card === ACCORDION_CARDS.DOWN_PAYMENT,
                        refreshAccountList: refreshAccountList,
                        storeNewlyAddedCreditCard: _storeNewlyAddedCreditCard,
                        markCreditCardForDeletion: _markCreditCardForDeletion,
                        setRecurringPaymentInstrumentById,
                        setDownPaymentInstrumentById,
                        refreshData,
                        isSplUser,
                        setSaveCreditCard: updateSaveFlag
                    }
                };

                return modalApi.showModal(
                    <FormModalPopover {...componentProps} />
                ).catch(() => {
                    return refreshAccountList().then((instruments) => {
                        if (isSplUser() || isGPA) {
                            const type = card === ACCORDION_CARDS.DOWN_PAYMENT ? DOWNPAYMENT_INSTRUMENT_TYPE : RECURRING_INSTRUMENT_TYPE;
                            const newPaymentInstrumentList = instruments.filter((instr) => instr.paymentMethod === paymentMethodType);
                            if (newPaymentInstrumentList.length > existingPaymentInstrumentList.length) {
                                // find credit card that was added
                                const newInstrument = instruments.find((instrument) => instrument.paymentMethod === paymentMethodType && !existingPaymentInstrumentList.includes(instrument.token));
                                if (newInstrument && type === RECURRING_INSTRUMENT_TYPE) {
                                    setRecurringPaymentInstrumentById(instruments, newInstrument.token);
                                } else if (newInstrument && type === DOWNPAYMENT_INSTRUMENT_TYPE) {
                                    setDownPaymentInstrumentById(instruments, newInstrument.token);
                                    if (!saveFlag.current) {
                                        _markCreditCardForDeletion(newInstrument.token);
                                        _storeNewlyAddedCreditCard(newInstrument.token);
                                    }
                                }
                            } else if (newPaymentInstrumentList.length === 1) {
                                // eslint-disable-next-line no-use-before-define
                                _defaultPaymentInstrument(newPaymentInstrumentList, type, undefined);
                            }
                        }
                        refreshData();
                    }).catch((error) => {
                        console.log(error);
                    });
                });
            }
        }).catch((error) => {
            console.log(error);
        });
    }, [view.paymentDetails, view.accountNumber.value, submissionVM, isSplUser, authHeader, showProgressDialog, hasPaymentInstrumentsForMethod, paymentInstruments, translator, refreshAccountList, _storeNewlyAddedCreditCard, _markCreditCardForDeletion, setRecurringPaymentInstrumentById, setDownPaymentInstrumentById, refreshData, _defaultPaymentInstrument, setPaymentDetailsUrl]);

    const _addBankAccountPaymentInstrument = useCallback((instrumentType) => {
        if (hasPaymentInstrumentsForMethod(MLAccountPaymentMethods.BANK_ACCOUNT)) {
            const onSaveAction = (bankAccountDetails) => {
                saveNewBankAccountPaymentInstrument(bankAccountDetails, instrumentType);
                return true;
            };

            const componentProps = {
                title: translator(messages.AddAccount),
                CustomComponent: MLBankAccountDetailsComponent,
                overrideProps: {
                    bankAccountDetails: newBankAccountDetails(),
                    instrumentType: instrumentType,
                    showCancel: true
                },
                onSaveAction: onSaveAction
            };

            modalApi.showModal(
                <FormModalPopover {...componentProps} />
            );
        }
    }, [newBankAccountDetails, hasPaymentInstrumentsForMethod, saveNewBankAccountPaymentInstrument, translator]);

    const addRecurringPaymentInstrument = useCallback(() => {
        const paymentMethod = view.paymentDetails.paymentMethod.value;
        if (paymentMethod === MLAccountPaymentMethods.CREDIT_CARD) {
            _addPaymentusPaymentInstrument(ACCORDION_CARDS.RECURRING_PAYMENT, MLAccountPaymentMethods.CREDIT_CARD);
        } else if (paymentMethod === MLAccountPaymentMethods.BANK_ACCOUNT) {
            if (usePaymentusAch) {
                _addPaymentusPaymentInstrument(ACCORDION_CARDS.RECURRING_PAYMENT, MLAccountPaymentMethods.BANK_ACCOUNT);
            } else {
                _addBankAccountPaymentInstrument(RECURRING_INSTRUMENT_TYPE);
            }
        }
    }, [_addBankAccountPaymentInstrument, _addPaymentusPaymentInstrument, usePaymentusAch, view.paymentDetails.paymentMethod.value]);

    const addDownPaymentInstrument = useCallback(() => {
        const paymentMethod = view.paymentDetails.downPaymentMethod_ML.value;
        if (paymentMethod === MLAccountPaymentMethods.CREDIT_CARD) {
            _addPaymentusPaymentInstrument(ACCORDION_CARDS.DOWN_PAYMENT, MLAccountPaymentMethods.CREDIT_CARD);
        } else if (paymentMethod === MLAccountPaymentMethods.BANK_ACCOUNT) {
            if (usePaymentusAch) {
                _addPaymentusPaymentInstrument(ACCORDION_CARDS.DOWN_PAYMENT, MLAccountPaymentMethods.BANK_ACCOUNT);
            } else {
                _addBankAccountPaymentInstrument(DOWNPAYMENT_INSTRUMENT_TYPE);
            }
        }
    }, [_addBankAccountPaymentInstrument, _addPaymentusPaymentInstrument, usePaymentusAch, view.paymentDetails.downPaymentMethod_ML.value]);

    const _removePortalUnavailableInstrument = (instruments, oldInstrumentId, newInstrumentId) => {
        if (oldInstrumentId !== newInstrumentId) {
            const index = instruments.findIndex((instrument) => {
                return instrument.token === oldInstrumentId;
            });
            if (index > -1) {
                instruments.splice(index, 1);
            }
        }
    };

    const saveBankAccountDetails = (bankAccountDetails, isRecurringInstrument, isDownpaymentInstrument) => {
        let promiseForBankAccount;
        if (qnbMode) {
            _populatePaymentDetailsView(bankAccountDetails);
            view.paymentDetails.bankName_ML = BOA_BANK_NAME;
            promiseForBankAccount = MLPaymentService.updateBankAccountDetailsWithSession(
                view.paymentDetails.value
            );
        } else {
            promiseForBankAccount = MLPaymentService.updateBankAccountDetails(
                bankAccountDetails.value,
                view.accountNumber.value,
                gpaMode,
                authHeader
            );
        }
        showProgressDialog(platformMessages.loading, promiseForBankAccount);

        promiseForBankAccount.then((instrumentId) => {
            refreshAccountList().then((instruments) => {
                setPaymentInstruments(instruments);
                _removePortalUnavailableInstrument(instruments, bankAccountDetails.value.publicID, instrumentId);
                if (isRecurringInstrument) {
                    setRecurringPaymentInstrumentById(instruments, instrumentId);
                } else {
                    setDownPaymentInstrumentById(instruments, instrumentId);
                }
            });
        }).catch((error) => goToContactUs(error));
    };

    const _isMortgagePlanSelected = () => {
        return view.paymentDetails.ratingPaymentMethod_ML.value.code === 'mortgagee';
    };

    const _isReferralAgentsEligible = useCallback(() => {
        if (isGcsUser() && view.referralAgents_ML.length > 0) {
            return isReferralAgentValid;
        }
        return true;
    }, [isGcsUser, isReferralAgentValid, view.referralAgents_ML.length]);

    const isMakePaymentButtonDisabled = useCallback(() => {
        return (isPayByMortgageFirstYear() && !commissions.valid)
            || ((isCreditDebitSelected() || isBankAccountSelected()) && !view.paymentDetails.selectedPaymentInstrument_ML.value)
            || isMortgageePartyMissing() || !_isReferralAgentsEligible() || showRecurringPaymentInstrumentError;
    }, [_isReferralAgentsEligible, commissions.valid, isBankAccountSelected, isCreditDebitSelected, isMortgageePartyMissing, isPayByMortgageFirstYear, view.paymentDetails.selectedPaymentInstrument_ML.value]);

    const isDownPaymentInstrumentSelected = useCallback(() => {
        return !(_.isUndefined(view.paymentDetails.downPaymentInstrument_ML.value) || view.paymentDetails.downPaymentInstrument_ML.value === null);
    }, [view.paymentDetails.downPaymentInstrument_ML.value]);

    const _isCreditCardAvailable = useCallback(() => {
        if (!gpaMode) {
            return true;
        }

        if (currentUser && currentUser.userType === MLUserTypes.PCS && currentUser.primaryProducerCode_ML.producerType_ML === MLProducerTypes.IA) {
            return true;
        }
        if (currentUser && currentUser.userType !== MLUserTypes.PCS) {
            return true;
        }
        if (isCitrixSecureEnv) {
            return true;
        }
        return false;
    }, [currentUser, isCitrixSecureEnv]);

    const isDownPaymentOverride = useCallback(() => {
        return !!view.paymentDetails.downPaymentOverride_ML.value;
    }, [view.paymentDetails.downPaymentOverride_ML.value]);

    const hidePaymentScheduleSection = useCallback(() => {
        return isPayByMortgageFirstYear() || isPayrollDeductionSelected();
    }, [isPayByMortgageFirstYear, isPayrollDeductionSelected]);

    const hidePaymentDetailsSection = useCallback(() => {
        return isMortgageeSelected() || isPayrollDeductionSelected() || isPayOnlineOrMailSelected();
    }, [isMortgageeSelected, isPayOnlineOrMailSelected, isPayrollDeductionSelected]);

    const hideDownPaymentSection = useCallback(() => {
        return isPayByMortgageFirstYear() || isPayrollDeductionSelected() || isDownPaymentOverride();
    }, [isDownPaymentOverride, isPayByMortgageFirstYear, isPayrollDeductionSelected]);

    const canShowCreditCard = () => {
        return true;
    };

    // ==================== Accordioin (START) ==================== //
    const onPayThroughMortgageChange = useCallback((value) => {
        view.paymentDetails.isPayThroughMortgage_ML.value = value;
        if (value === false) {
            view.paymentDetails.firstYear_ML.value = null;
        }
    }, [view.paymentDetails.firstYear_ML, view.paymentDetails.isPayThroughMortgage_ML]);

    const _setPayrollDeductFieldsAvailability = useCallback(() => {
        if (gafInfo) {
            if(qnbMode && !gafInfo?.alternateIdUsage?.value) {
                    setHasSsn(true);
            } else {
                setHasSsn(!!gafInfo.ssn?.value);
            }

            setHasDepartmentNumber(!!gafInfo.departmentNumber?.value);
            setHasEmployeeNumber(!!gafInfo.employeeNumber?.value);
            setHasMetroBadgeNumber(!!gafInfo.metroBadgeNumber?.value);
        } else {
            setHasSsn(false);
            setHasDepartmentNumber(false);
            setHasEmployeeNumber(false);
            setHasMetroBadgeNumber(false);
        }
    }, [gafInfo]);

    const setFaqSection = useCallback((faqId) => {
        setHowPaymentWorks(translator(messages.PaymentPlanFaqSection, faqId));
    }, [translator]);

    const setPaymentMethod = useCallback((aRatingPaymentMethod) => {
        let aPaymentMethod = null;

        switch (aRatingPaymentMethod) {
            case MLRatingPaymentMethods.CREDIT_CARD:
                aPaymentMethod = MLAccountPaymentMethods.CREDIT_CARD;
                break;
            case MLRatingPaymentMethods.BANK_ACCOUNT:
                aPaymentMethod = MLAccountPaymentMethods.BANK_ACCOUNT;
                break;
            case MLRatingPaymentMethods.PAY_ONLINE_OR_BY_MAIL:
            case MLRatingPaymentMethods.MORTGAGEE:
                aPaymentMethod = MLAccountPaymentMethods.RESPONSIVE;
                break;
            case MLRatingPaymentMethods.PAYROLL_DEDUCT:
                aPaymentMethod = MLAccountPaymentMethods.PAYROLL_DEDUCT;
                break;
            default:
                break;
        }
        if (view.paymentDetails.paymentMethod.value !== aPaymentMethod) {
            view.paymentDetails.selectedPaymentInstrument_ML = null;
            view.paymentDetails.paymentMethod.value = aPaymentMethod;
        }
    }, [view.paymentDetails]);
    const selectPreferredPaymentMethodInd = useCallback(
        (value) => {
            view.paymentDetails.preferredPaymentMethodInd_Ext.value = value;
            updateWizardData(submissionVM);
            const isPersonalAutoOrProperty = _.includes(["PersonalAuto", "HOPHomeowners"], submissionVM?.baseData?.productCode?.value)
            if(isModernProduct && isPersonalAutoOrProperty) {
                view.paymentDetails.isInPaymentDetailsPage_ML.value = false;
            }
            if ((qnbMode || isPersonalAutoOrProperty) && isModernProduct) {
                showProgressDialog(platformMessages.saveSubmission);
                const updatePromise = LoadSaveService.updateQuotedSubmission(
                    submissionVM.value,
                    authHeader
                )
                updatePromise.then((data) => {
                    submissionVM.quoteData.value = data.quoteData;
                    const selectedChosenQuoteData =
                    getChosenQuoteDataFromQuotes(
                        data.quoteData.offeredQuotes,
                        view.chosenQuote.value
                    );
                    setChosenQuoteData(selectedChosenQuoteData);
                    view.paymentDetails.downPaymentOverride_ML = data.bindData.paymentDetails.downPaymentOverride_ML;
                    const paymentMethod = view.paymentDetails.ratingPaymentMethod_ML.value.code;
                    const fullPayPlan = _createPaymentPlanObject(
                        paymentMethod,
                        FULL_PAY_SCHEDULE
                    );
                    if (isModernProduct && isPersonalAutoOrProperty) {
                        view.paymentDetails.isInPaymentDetailsPage_ML.value = true;
                    }
                    const quotePromise = _quotePaymentPlan(
                        submissionVM.sessionUUID.value,
                        fullPayPlan,
                        selectedChosenQuoteData, // use latest value
                        offeredQuotes
                    );
                    if (quotePromise) {
                        quotePromise.then(
                             (createdQuote) => {
                                const index = offeredQuotes.findIndex(q => q.publicID == createdQuote.quote.publicID
                                    && q.ratingPaymentSchedule_ML === createdQuote.quote.ratingPaymentSchedule_ML
                                    && q.ratingPaymentMethod_ML === createdQuote.quote.ratingPaymentMethod_ML
                                );                                 
                                if(index !== -1) {
                                    offeredQuotes[index] = createdQuote.quote
                                } else {
                                    offeredQuotes.push(createdQuote.quote);
                                }  
                                offeredQuotesDownPaymentDetails_ML.push(
                                    createdQuote.downPaymentOverride
                                );
                                hideProgressDialog();
                                onPreferredPaymentChangedAlert(value);
                            },
                            (error) => {
                                console.error(error);
                                hideProgressDialog();
                            });
                        } else {
                            hideProgressDialog();
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        hideProgressDialog();
                    });
                }
            },
            [
                submissionVM,
                updateWizardData,
                view.paymentDetails.preferredPaymentMethodInd_Ext,
                authHeader,
                offeredQuotes,
                offeredQuotesDownPaymentDetails_ML,
                qnbMode,
                isModernProduct
            ]
        );

    const selectPaymentPlan = useCallback((selectedPlanID) => {
        let selectedChosenQuoteData = chosenQuoteData;
        clearBlockAlerts('changingPreferredPayment');
        switch (selectedPlanID) {
            case MLMortgageePayPlanPublicId:
                if (view.paymentDetails.firstYear_ML.value) {
                    view.paymentDetails.selectedPaymentPlan_ML.value = MLMortgageePayPlanPublicId;
                } else {
                    view.paymentDetails.selectedPaymentPlan_ML.value = MLAnnuallyPayPlanPublicId;
                }
                selectedChosenQuoteData = getMortgageePlanPeriodFromQuotes(offeredQuotes, view.chosenQuote.value, isPayByMortgageFirstYear()) || chosenQuoteData;
                setChosenQuoteData(selectedChosenQuoteData);
                break;
            case MLAnnuallyPayPlanPublicId:
                view.paymentDetails.selectedPaymentPlan_ML.value = MLAnnuallyPayPlanPublicId;
                selectedChosenQuoteData = getFullPayPlanPeriodFromQuotes(offeredQuotes, getRatingPaymentMethodCode(), view.chosenQuote.value) || chosenQuoteData;
                setChosenQuoteData(selectedChosenQuoteData);
                break;
            case MLMonthlyPayPlanPublicId:
                view.paymentDetails.selectedPaymentPlan_ML.value = MLMonthlyPayPlanPublicId;
                selectedChosenQuoteData = getInstallmentsPlanPeriodFromQuotes(offeredQuotes, getRatingPaymentMethodCode(), view.chosenQuote.value) || chosenQuoteData;
                setChosenQuoteData(selectedChosenQuoteData);
                setFaqSection('how-does-monthly-pay-option-work');
                break;
            case MLMonthlySemiAnnualResponsivePlanPublicId:
                view.paymentDetails.selectedPaymentPlan_ML.value = MLMonthlySemiAnnualResponsivePlanPublicId;
                selectedChosenQuoteData = getInstallmentsPlanPeriodFromQuotes(offeredQuotes, getRatingPaymentMethodCode(), view.chosenQuote.value) || chosenQuoteData;
                setChosenQuoteData(selectedChosenQuoteData);
                setFaqSection('how-does-monthly-pay-option-work');
                break;
            case MLMonthlyAnnualResponsivePlanPublicId:
                view.paymentDetails.selectedPaymentPlan_ML.value = MLMonthlyAnnualResponsivePlanPublicId;
                selectedChosenQuoteData = getInstallmentsPlanPeriodFromQuotes(offeredQuotes, getRatingPaymentMethodCode(), view.chosenQuote.value) || chosenQuoteData;
                setChosenQuoteData(selectedChosenQuoteData);
                setFaqSection('how-does-monthly-pay-option-work');
                break;
            case FMPAMonthlySemiAnnualResponsivePlanPublicId:
                view.paymentDetails.selectedPaymentPlan_ML.value = FMPAMonthlySemiAnnualResponsivePlanPublicId;
                selectedChosenQuoteData = getInstallmentsPlanPeriodFromQuotes(offeredQuotes, getRatingPaymentMethodCode(), view.chosenQuote.value) || chosenQuoteData;
                setChosenQuoteData(selectedChosenQuoteData);
                setFaqSection('how-does-monthly-pay-option-work');
                break;
            case FMPAMonthlyAnnualResponsivePlanPublicId:
                view.paymentDetails.selectedPaymentPlan_ML.value = FMPAMonthlyAnnualResponsivePlanPublicId;
                selectedChosenQuoteData = getInstallmentsPlanPeriodFromQuotes(offeredQuotes, getRatingPaymentMethodCode(), view.chosenQuote.value) || chosenQuoteData;
                setChosenQuoteData(selectedChosenQuoteData);
                setFaqSection('how-does-monthly-pay-option-work');
                break;
            case NPTwoPayAnnualAutoPay:
                view.paymentDetails.selectedPaymentPlan_ML.value = NPTwoPayAnnualAutoPay;
                selectedChosenQuoteData = getInstallmentsPlanPeriodFromQuotes(offeredQuotes, getRatingPaymentMethodCode(), view.chosenQuote.value) || chosenQuoteData;
                setChosenQuoteData(selectedChosenQuoteData);
                break;
            case MLTwicePerMonthPayPlanPublicId:
                view.paymentDetails.selectedPaymentPlan_ML.value = MLTwicePerMonthPayPlanPublicId;
                selectedChosenQuoteData = getInstallmentsPlanPeriodFromQuotes(offeredQuotes, getRatingPaymentMethodCode(), view.chosenQuote.value) || chosenQuoteData;
                setChosenQuoteData(selectedChosenQuoteData);
                setFaqSection('how-does-twice-per-month-payment-work');
                break;
            case MLTwoPayAnnualPlanPublicId:
                view.paymentDetails.selectedPaymentPlan_ML.value = MLTwoPayAnnualPlanPublicId;
                selectedChosenQuoteData = getInstallmentsPlanPeriodFromQuotes(offeredQuotes, getRatingPaymentMethodCode(), view.chosenQuote.value) || chosenQuoteData;
                setChosenQuoteData(selectedChosenQuoteData);
                setFaqSection('how-does-two-pay-payment-work');
                break;
            case MLTwoPaySemiAnnualPlanPublicId:
                view.paymentDetails.selectedPaymentPlan_ML.value = MLTwoPaySemiAnnualPlanPublicId;
                selectedChosenQuoteData = getInstallmentsPlanPeriodFromQuotes(offeredQuotes, getRatingPaymentMethodCode(), view.chosenQuote.value) || chosenQuoteData
                setChosenQuoteData(selectedChosenQuoteData);
                setFaqSection('how-does-two-pay-payment-work');
                break;
            case MLFourPayAnnualPlanPublicId:
                view.paymentDetails.selectedPaymentPlan_ML.value = MLFourPayAnnualPlanPublicId;
                selectedChosenQuoteData = getInstallmentsPlanPeriodFromQuotes(offeredQuotes, getRatingPaymentMethodCode(), view.chosenQuote.value) || chosenQuoteData;
                setChosenQuoteData(selectedChosenQuoteData);
                setFaqSection('how-does-four-pay-payment-work');
                break;
            case MLPayrollDeductPlanPublicId:
                view.paymentDetails.selectedPaymentPlan_ML.value = MLPayrollDeductPlanPublicId;
                selectedChosenQuoteData = getMonthlyPayrollDeductPlanPeriodFromQuotes(offeredQuotes, view.chosenQuote.value) || chosenQuoteData;
                setChosenQuoteData(selectedChosenQuoteData);
                break;
            case null:
                view.paymentDetails.selectedPaymentPlan_ML.value = null;
                break;
            default:
                break;
        }
        view.chosenQuote.value = selectedChosenQuoteData.publicID;
        view.paymentDetails.downPaymentOverride_ML = offeredQuotesDownPaymentDetails_ML[offeredQuotes.indexOf(selectedChosenQuoteData)];
        setSelectedScheduleFromQuotePage(selectedChosenQuoteData.ratingPaymentSchedule_ML);
        // BUNDLE TODO
        // MLBundleService.setPremiumForJob($scope.chosenQuoteData.quoteID, $scope.chosenQuoteData.total);
    }, [chosenQuoteData, getFullPayPlanPeriodFromQuotes, getInstallmentsPlanPeriodFromQuotes, getMonthlyPayrollDeductPlanPeriodFromQuotes, getMortgageePlanPeriodFromQuotes, getRatingPaymentMethodCode, isPayByMortgageFirstYear, offeredQuotes, offeredQuotesDownPaymentDetails_ML, setFaqSection, view.chosenQuote, view.paymentDetails]);

    const setRatingPaymentMethod = useCallback((aRatingPaymentMethod) => {
        view.paymentDetails.ratingPaymentMethod_ML.value = aRatingPaymentMethod;
        if (aRatingPaymentMethod !== MLRatingPaymentMethods.MORTGAGEE) {
            selectPaymentPlan(null);
        }
    }, [selectPaymentPlan, view.paymentDetails.ratingPaymentMethod_ML]);

    const _setDefaultPaymentMethod = useCallback((isMortgagePlanSelected = false, isBankOptionAvailable = false, paymentMethodValue = undefined) => {
        // PaymentMethod should have a value which is selected by a customer.
        // On the other than, RatingPaymentMethod may be back to default (Credit Card),
        // That's why we need to check the PaymentMethod value and re-assign.
        if (!isMortgagePlanSelected) {
            onPayThroughMortgageChange(false);
        }
        if (paymentMethodValue === MLAccountPaymentMethods.BANK_ACCOUNT || paymentMethodValue === MLRatingPaymentMethods.BANK_ACCOUNT) {
            if (isBankOptionAvailable) {
                setPaymentMethod(MLRatingPaymentMethods.BANK_ACCOUNT);
            } else if (_isCreditCardAvailable()) {
                view.paymentDetails.ratingPaymentMethod_ML.value = MLRatingPaymentMethods.CREDIT_CARD;
                setPaymentMethod(MLRatingPaymentMethods.CREDIT_CARD);
            } else {
                view.paymentDetails.ratingPaymentMethod_ML.value = MLRatingPaymentMethods.PAY_ONLINE_OR_BY_MAIL;
                setPaymentMethod(MLRatingPaymentMethods.PAY_ONLINE_OR_BY_MAIL);
            }
        } else if (paymentMethodValue === MLRatingPaymentMethods.CREDIT_CARD) {
            setPaymentMethod(MLRatingPaymentMethods.CREDIT_CARD);
        } else if (paymentMethodValue === MLRatingPaymentMethods.PAYROLL_DEDUCT) {
            setPaymentMethod(MLRatingPaymentMethods.PAYROLL_DEDUCT);
        } else if (isMortgagePlanSelected === true) {
            view.paymentDetails.isPayThroughMortgage_ML.value = true;
            setRatingPaymentMethod(MLRatingPaymentMethods.MORTGAGEE);
        } else {
            setRatingPaymentMethod(MLRatingPaymentMethods.PAY_ONLINE_OR_BY_MAIL);
            setPaymentMethod(MLRatingPaymentMethods.PAY_ONLINE_OR_BY_MAIL);
        }
    }, [view.paymentDetails.isPayThroughMortgage_ML, view.paymentDetails.ratingPaymentMethod_ML, onPayThroughMortgageChange, _isCreditCardAvailable, setPaymentMethod, setRatingPaymentMethod]);

    const goToSelectedAccordion = useCallback((card) => {
        setCurrentCard(card);
        // Before selecting payment plan, user needs to update the quote with eligibility information
        if (card === ACCORDION_CARDS.GROUP_DISCOUNT) {
            view.paymentDetails.isInPaymentDetailsPage_ML.value = false;
        }
    }, [setCurrentCard, view.paymentDetails.isInPaymentDetailsPage_ML]);

    // Payment Instrument actions
    const editPaymentInstrument = (token, paymentMethod, isRecurringInstrument = false) => {
        if (paymentMethod === MLAccountPaymentMethods.CREDIT_CARD ||
            (usePaymentusAch && paymentMethod === MLAccountPaymentMethods.BANK_ACCOUNT)) {
            const promiseForEditPaymentInstrumentUrl = MLPaymentService.editPaymentInstrument(
                submissionVM.sessionUUID.value,
                submissionVM.quoteID.value,
                token,
                `${window.location.protocol}//${window.location.host}${MLJpmcResponsePath}`,
                view.accountNumber.value,
                gpaMode,
                authHeader
            );
            showProgressDialog(platformMessages.loading, promiseForEditPaymentInstrumentUrl);

            promiseForEditPaymentInstrumentUrl.then((iframeUrl) => {
                const iframeHeight = isSplUser() ? '500px' : '600px';
                const iframeWidth = isSplUser() ? '350px' : '375px';
                const instrumentType = currentCard === ACCORDION_CARDS.DOWN_PAYMENT ? DOWNPAYMENT_INSTRUMENT_TYPE : RECURRING_INSTRUMENT_TYPE;

                const componentProps = {
                    title: translator(messages.EditAccount),
                    CustomComponent: MLCreditCardDetailsComponent,
                    overrideProps: {
                        jpmcURL: iframeUrl,
                        iframeHeight: iframeHeight,
                        iframeWidth: iframeWidth,
                        refreshAccountList: refreshAccountList,
                        instrumentType: instrumentType,
                        isEditAccount: true
                    }
                };

                modalApi.showModal(
                    <FormModalPopover {...componentProps} />
                );
            }).catch((error) => {
                console.log(error);
            });
        } else if (paymentMethod === MLAccountPaymentMethods.BANK_ACCOUNT ||
            (!usePaymentusAch && paymentMethod === MLAccountPaymentMethods.BANK_ACCOUNT)) {
            let promiseForGetBankAccountDetails;

            if (qnbMode) {
                promiseForGetBankAccountDetails = MLPaymentService.getBankAccountDetailsWithSession(
                    submissionVM.sessionUUID.value,
                    submissionVM.quoteID.value,
                    token
                );
            } else {
                promiseForGetBankAccountDetails = MLPaymentService.getBankAccountDetails(
                    token,
                    view.accountNumber.value,
                    gpaMode,
                    authHeader
                );
            }

            showProgressDialog(platformMessages.loading, promiseForGetBankAccountDetails);

            promiseForGetBankAccountDetails.then((details) => {
                const bankAccountDetails = newBankAccountDetails();
                Object.keys(details).forEach((key) => {
                    if (Object.prototype.hasOwnProperty.call(details, key)) {
                        bankAccountDetails[key] = details[key];
                    }
                });

                bankAccountDetails.confirmAccountNumber.value = details.accountNumber;

                const onSaveAction = () => {
                    saveBankAccountDetails(bankAccountDetails, isRecurringInstrument);
                    return true;
                };

                const componentProps = {
                    title: translator(messages.EditAccount),
                    CustomComponent: MLBankAccountDetailsComponent,
                    overrideProps: {
                        bankAccountDetails: bankAccountDetails,
                        showCancel: true
                    },
                    onSaveAction: onSaveAction
                };

                modalApi.showModal(
                    <FormModalPopover {...componentProps} />
                );
            }).catch((error) => {
                console.log(error);
            });
        }
    };

    const numberOfPaymentInstrumentsForMethod = (method) => {
        let numPaymentInstruments = 0;

        paymentInstruments.forEach((paymentInstrument) => {
            if (paymentInstrument.paymentMethod === method
                && (paymentInstrument.portalAvailable !== false || paymentInstrument.paymentMethod === MLAccountPaymentMethods.CREDIT_CARD)) {
                numPaymentInstruments += 1;
            }
        });

        return numPaymentInstruments;
    };

    const skipOnResumeIf = () => {
        // Skip to Confirmation Page for policy with a policy number
        if (!!_.get(submissionVM, 'bindData.policyNumber.value')
            && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
            return true;
        }

        if (submissionVM.isBundle_ML.value && submissionVM.value.baseData.status_ML !== 'Draft' &&
            MLMultiLobsDataHolderService.isBeforeLastPurchaseFlowStepVisited('paymentDetails', submissionVM.value)) {
            return true;
        }
        return !!_.get(submissionVM, 'bindData.policyNumber.value') && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding');
    };

    const [paymentInstrumentsForAllPolicies, setPaymentInstrumentsForAllPolicies] = useState([]);
    useEffect(() => {
        if ((!isSkipping || (isSkipping && !skipOnResumeIf())) && gpaMode) {
            MLPaymentService.getPolicyPaymentInstrumentsForAccount(view.accountNumber.value, gpaMode, authHeader).then((instruments) => {
                setPaymentInstrumentsForAllPolicies(instruments);
            }).catch(_.noop);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    

    const canRemovePaymentInstrument = (token) => {
        if (getType() === DOWNPAYMENT_INSTRUMENT_TYPE) {
            if (view.paymentDetails.selectedPaymentInstrument_ML.value === token) {
                return false;
            }
            return numberOfPaymentInstrumentsForMethod(view.paymentDetails.downPaymentMethod_ML.value) > 1 && Array.isArray(paymentInstrumentsForAllPolicies) && paymentInstrumentsForAllPolicies.findIndex((instrumentToken) => instrumentToken === token) === -1;
        }
        return numberOfPaymentInstrumentsForMethod(view.paymentDetails.paymentMethod.value) > 1
            && Array.isArray(paymentInstrumentsForAllPolicies) && paymentInstrumentsForAllPolicies.findIndex((instrumentToken) => instrumentToken === token) === -1;
    };

    const deletePaymentInstrument = (token, paymentMethod) => {
        if (paymentMethod === MLAccountPaymentMethods.CREDIT_CARD ||
            (usePaymentusAch && paymentMethod === MLAccountPaymentMethods.BANK_ACCOUNT)) {
            const promiseForDeletePaymentInstrument = MLPaymentService.deletePaymentInstrument(
                submissionVM.sessionUUID.value,
                submissionVM.quoteID.value,
                token,
                view.accountNumber.value,
                gpaMode,
                authHeader
            );

            showProgressDialog(platformMessages.loading, promiseForDeletePaymentInstrument);

            promiseForDeletePaymentInstrument.then(() => {
                refreshAccountList().then((pms) => {
                    setPaymentInstruments(pms);
                    if (token === view.paymentDetails.selectedPaymentInstrument_ML.value && !pms.some((instrument) => instrument.token === view.paymentDetails.selectedPaymentInstrument_ML.value)) {
                        // mark that no payment instrument is selected if it is deleted
                        view.paymentDetails.selectedPaymentInstrument_ML.value = null;
                        _defaultPaymentInstrument(pms, RECURRING_INSTRUMENT_TYPE, false);
                    }
                    if (token === view.paymentDetails.downPaymentInstrument_ML.value && !pms.some((instrument) => instrument.token === view.paymentDetails.downPaymentInstrument_ML.value)) {
                        // mark that no payment instrument is selected if it is deleted
                        view.paymentDetails.downPaymentInstrument_ML.value = null;
                        _defaultPaymentInstrument(pms, DOWNPAYMENT_INSTRUMENT_TYPE, false);
                    }
                });
            }).catch((error) => goToContactUs(error));
        } else if (paymentMethod === MLAccountPaymentMethods.BANK_ACCOUNT ||
            (!usePaymentusAch && paymentMethod === MLAccountPaymentMethods.BANK_ACCOUNT)) {
            let promiseForDeleteBankAccount;
            if (qnbMode) {
                promiseForDeleteBankAccount = MLPaymentService.deleteBankAccountInstrumentWithSession(
                    submissionVM.sessionUUID.value,
                    submissionVM.quoteID.value,
                    token
                );
            } else {
                promiseForDeleteBankAccount = MLPaymentService.deleteBankAccountInstrument(
                    token,
                    view.accountNumber.value,
                    gpaMode,
                    authHeader
                );
            }

            showProgressDialog(platformMessages.loading, promiseForDeleteBankAccount);

            promiseForDeleteBankAccount.then((deleteFlag) => {
                if (deleteFlag) {
                    refreshPaymentInstruments().then((pms) => {
                        setPaymentInstruments(pms);
                        if (token === view.paymentDetails.selectedPaymentInstrument_ML.value && !pms.filter((instrument) => instrument.portalAvailable !== false).some((instrument) => instrument.token === view.paymentDetails.selectedPaymentInstrument_ML.value)) {
                            // mark that no payment instrument is selected if it is deleted
                            view.paymentDetails.selectedPaymentInstrument_ML.value = null;
                            _defaultPaymentInstrument(pms, RECURRING_INSTRUMENT_TYPE, false);
                        }
                        if (token === view.paymentDetails.downPaymentInstrument_ML.value && !pms.filter((instrument) => instrument.portalAvailable !== false).some((instrument) => instrument.token === view.paymentDetails.downPaymentInstrument_ML.value)) {
                            // mark that no payment instrument is selected if it is deleted
                            view.paymentDetails.downPaymentInstrument_ML.value = null;
                            _defaultPaymentInstrument(pms, DOWNPAYMENT_INSTRUMENT_TYPE, false);
                        }
                    });
                } else {
                    showErrorModal(messages.FailedToRemoveAccount, messages.FailedToRemoveAccountMessage);
                }
            }).catch((error) => goToContactUs(error));
        }
    };

    const _quotePaymentPlan = useCallback((sessionID, paymentPlan, quote, createdQuotes) => {
        const baseOfferingQuoteId = getBaseOfferingQuote(createdQuotes, quote.publicID).publicID;
        return CustomQuoteService.createQuoteForSpecificPaymentPlanAndGetDownPaymentDetails_ML(sessionID, quote.quoteID, baseOfferingQuoteId, paymentPlan, authHeader);
    }, [CustomQuoteService, getBaseOfferingQuote, authHeader]);

    const updateHomeLosses = (newQuote) => {
        if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
            _.set(submissionVM, 'lobData.homeowners.coverables.disclosures_ML.losses.value', newQuote.quote.homeLosses_ML);
        } else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
            _.set(submissionVM, 'lobData.personalUmbrella.coverables.homeLosses_ML.value', newQuote.quote.homeLosses_ML);
        }
    };

    const onPaymentInstrumentChange = (paymentInstrumentToken, recurringOrDownPayment) => {
        if (!_.isUndefined(paymentInstrumentToken)) {
            setShowRecurringPaymentInstrumentError(false);
            setShowDownPaymentInstrumentError(false);

            const paymentInstrument = paymentInstruments.find((instrument) => instrument.token === paymentInstrumentToken);
            if (!_.isUndefined(paymentInstrument)) {
                if (recurringOrDownPayment === 'recurring') {
                    setRecurringPaymentInstrumentById(paymentInstruments, paymentInstrumentToken);
                } else {
                    setDownPaymentInstrumentById(paymentInstruments, paymentInstrumentToken);
                }

                // preferred payment method is true so check to see if credit card type to is not debit and show message if it is
                if (isModernProduct && view.paymentDetails.preferredPaymentMethodInd_Ext.value === true) {
                    if (NON_PREFERRED_PAYMENT_METHODS.includes(paymentInstrument.accountType_ML)) {
                        if (recurringOrDownPayment === 'recurring') {
                            setShowRecurringPaymentInstrumentError(true);
                            view.paymentDetails.selectedPaymentInstrument_ML.value = null;
                        } else {
                            setShowDownPaymentInstrumentError(true);
                            view.paymentDetails.downPaymentInstrument_ML.value = null;
                        }
                    }
                }
            } else {
                if (recurringOrDownPayment === 'recurring') {
                    view.paymentDetails.selectedPaymentInstrument_ML.value = null;
                } else {
                    view.paymentDetails.downPaymentInstrument_ML.value = null;
                }
            }
            refreshData();
        }
    };

    const onRecurringPaymentInstrumentChange = (paymentInstrumentToken) => {
        onPaymentInstrumentChange(paymentInstrumentToken, 'recurring');
    };

    const onDownPaymentInstrumentChange = (paymentInstrumentToken) => {
        onPaymentInstrumentChange(paymentInstrumentToken, 'downpayment');
    };

    const goToNextAccordion = useCallback(async (nextCard) => {
        view.paymentDetails.isInPaymentDetailsPage_ML = true;

        /** *******  PAYMENT SCHEDULE  *********/
        if (nextCard === ACCORDION_CARDS.PAYMENT_SCHEDULE) {
            if (chosenQuoteData.ratingPaymentMethod_ML !== MLRatingPaymentMethods.MORTGAGEE && chosenQuoteData.ratingPaymentMethod_ML !== MLRatingPaymentMethods.PAYROLL_DEDUCT) {
                const paymentPlan = _createPaymentPlanObject(chosenQuoteData.ratingPaymentMethod_ML, chosenQuoteData.ratingPaymentSchedule_ML);
            }
            if (isPayByMortgageSecondYear()) {
                view.paymentDetails.selectedPaymentPlan_ML.value = MLAnnuallyPayPlanPublicId;
            }
        }

        /** *******  RECURRING PAYMENT DETAILS  *********/
        if (nextCard === ACCORDION_CARDS.RECURRING_PAYMENT) {
            clearBlockAlerts('changingPreferredPayment');
            if (!isPayByMortgageFirstYear()) {
                const pms = await refreshPaymentInstruments();
                setPaymentInstruments(pms);
                if (hasPaymentInstrumentsForMethod(view.paymentDetails.paymentMethod.value) === false) {
                    if ((isCreditDebitSelected() || (usePaymentusAch && isBankAccountSelected())) && isSplUser()) {
                        view.paymentDetails.selectedPaymentInstrument_ML.value = null;
                    } else if (isCreditDebitSelected() && !isSplUser()) {
                        _addPaymentusPaymentInstrument(nextCard, MLAccountPaymentMethods.CREDIT_CARD);
                    } else if (isBankAccountSelected() && !isSplUser()) {
                        if (usePaymentusAch) {
                            _addPaymentusPaymentInstrument(nextCard, MLAccountPaymentMethods.BANK_ACCOUNT);
                        } else {
                            _addBankAccountPaymentInstrument(RECURRING_INSTRUMENT_TYPE);
                        }
                    }
                } else if (!_isValidPaymentInstrumentId(pms, view.paymentDetails.selectedPaymentInstrument_ML.value, view.paymentDetails.paymentMethod.value)) {
                    _defaultPaymentInstrument(pms, RECURRING_INSTRUMENT_TYPE);
                } else {
                    setRecurringPaymentInstrumentById(pms, view.paymentDetails.selectedPaymentInstrument_ML.value);
                }

                onRecurringPaymentInstrumentChange(view.paymentDetails.selectedPaymentInstrument_ML?.value);
            }
        }

        /** *******  DOWN PAYMENT  *********/
        if (nextCard === ACCORDION_CARDS.DOWN_PAYMENT) {
            if (isPCSAgent() && view.additionalProducers_ML.length > 0) {
                if (!commissions.valid) {
                    return;
                }
            }

            const pms = await refreshPaymentInstruments();
            setPaymentInstruments(pms);
            if (!view.paymentDetails.downPaymentInstrument_ML.value) {
                _defaultPaymentInstrument(pms, DOWNPAYMENT_INSTRUMENT_TYPE);
            } else {
                setPaymentChannel(view.paymentDetails.downPaymentMethod_ML.value);
            }

            onDownPaymentInstrumentChange(view.paymentDetails.selectedPaymentInstrument_ML?.value);
        }

        setCurrentCard(nextCard);
    }, [view.paymentDetails, view.additionalProducers_ML.length, isPayByMortgageSecondYear, isPayByMortgageFirstYear, refreshPaymentInstruments, hasPaymentInstrumentsForMethod, _addPaymentusPaymentInstrument, _addBankAccountPaymentInstrument, _defaultPaymentInstrument, isPCSAgent, commissions.valid, setPaymentChannel, setPaymentInstruments]);


    const updateGAFAndGoToNextAccordion = useCallback((nextCard) => {
        if(!_.isEmpty(gafInfo?.gpcCode.value) || !_.isUndefined(gafInfo?.gpcCode.value)) {
            gafInfo.isEditMode.value = showGroupDiscountSection;
            gafInfo.isEditPayrollDeduct.value = false;
        }
        
        let localEligiblityInfoChanged = false;

        if (!(gafInfo.aspects.valid && gafInfo.aspects.subtreeValid)) {
            return;
        }
        _setPayrollDeductFieldsAvailability();
        // GPC is mandatory for modern product GCS sales submissions (see AffiliationPage checkGPCCode); PC blocks quote without it
        const isGpcMandatory = isModernProduct
                && _.get(submissionVM, 'userType_ML.value.code', '') === 'gcssales_ml'
                && !_.get(submissionVM, 'disableGPCCheckForGcsSales_Ext.value', false);

        if (!qnbMode && ((shouldDeleteGafInfo(gafInfo) && !isGpcMandatory)
            || (!showGroupDiscountSection && gafSectionShownInitially)
            || (!showGroupDiscountSection && gafRadioSelectionChanged))) {
            gafInfo.gpcCode.value = null;
            gafInfo.payrollDeductAvailable.value = false;
            gafInfo.eligibilityVerified.value = undefined;
            setEligibilityInfoChanged(true);
            localEligiblityInfoChanged = true;
        }

        if (localEligiblityInfoChanged) {
            showProgressDialog(platformMessages.saving);
            const updatePromise = LoadSaveService.updateQuotedSubmission(submissionVM.value, authHeader);
            updatePromise.then((data) => {
                submissionVM.quoteData.value = data.quoteData;
                const selectedChosenQuoteData = getChosenQuoteDataFromQuotes(data.quoteData.offeredQuotes, view.chosenQuote.value);
                setChosenQuoteData(selectedChosenQuoteData);
                view.paymentDetails.downPaymentOverride_ML = data.bindData.paymentDetails.downPaymentOverride_ML;
                setEligibilityInfoChanged(false);
                view.paymentDetails.isInPaymentDetailsPage_ML = true;
                if (gafInfo.payrollDeductAvailable?.value) {
                    let quotePromise = null;
                    if (!_isPaymentPlanQuoted(MLRatingForMonthlyPayrollDeductPayment, offeredQuotes, selectedChosenQuoteData)) {
                        quotePromise = _quotePaymentPlan(submissionVM.sessionUUID.value, MLRatingForMonthlyPayrollDeductPayment, selectedChosenQuoteData, offeredQuotes);
                    }
                    if (quotePromise !== null) {
                        quotePromise.then((createdQuote) => {
                            updateHomeLosses(createdQuote);
                            offeredQuotes.push(createdQuote.quote);
                            offeredQuotesDownPaymentDetails_ML.push(createdQuote.downPaymentOverride);
                            goToNextAccordion(nextCard);
                            hideProgressDialog();
                        }, (error) => {
                            console.error(error);
                            goToNextAccordion(nextCard);
                            hideProgressDialog();
                        });
                    } else {
                        goToNextAccordion(nextCard);
                        hideProgressDialog();
                    }
                } else {
                    goToNextAccordion(nextCard);
                    hideProgressDialog();
                }
            }, (error) => {
                console.error(error);
                goToNextAccordion(nextCard);
                hideProgressDialog();
            });
        } else if (gafInfo.payrollDeductAvailable?.value && !qnbMode) {
            let quotePromise = null;
            if (!_isPaymentPlanQuoted(MLRatingForMonthlyPayrollDeductPayment, offeredQuotes, chosenQuoteData)) {
                quotePromise = _quotePaymentPlan(submissionVM.sessionUUID.value, MLRatingForMonthlyPayrollDeductPayment, chosenQuoteData, offeredQuotes);
            }
            if (quotePromise !== null) {
                showProgressDialog(platformMessages.saving);
                quotePromise.then((createdQuote) => {
                    updateHomeLosses(createdQuote);
                    offeredQuotes.push(createdQuote.quote);
                    offeredQuotesDownPaymentDetails_ML.push(createdQuote.downPaymentOverride);
                    goToNextAccordion(nextCard);
                    hideProgressDialog();
                }, (error) => {
                    console.error(error);
                    goToNextAccordion(nextCard);
                    hideProgressDialog();
                });
            } else {
                goToNextAccordion(nextCard);
            }
        } else {
            goToNextAccordion(nextCard);
        }
    }, [offeredQuotesDownPaymentDetails_ML, _quotePaymentPlan, _setPayrollDeductFieldsAvailability, chosenQuoteData, gafInfo, gafRadioSelectionChanged, gafSectionShownInitially, getChosenQuoteDataFromQuotes, goToNextAccordion, offeredQuotes, shouldDeleteGafInfo, showGroupDiscountSection, submissionVM.quoteData, submissionVM.sessionUUID.value, submissionVM.value, view.chosenQuote.value, view.paymentDetails, authHeader]);

    const _updateChosenQuoteWithQuoteData = useCallback((quoteData) => {
        submissionVM.quoteData.value = quoteData;
        setChosenQuoteData(quoteData);
        view.chosenQuote.value = quoteData.publicID;
        view.paymentDetails.downPaymentOverride_ML = offeredQuotesDownPaymentDetails_ML[offeredQuotes.indexOf(quoteData)];
    }, [offeredQuotes, offeredQuotesDownPaymentDetails_ML, submissionVM.quoteData, view.chosenQuote, view.paymentDetails]);

    const _updateChosenQuoteWithMethodAndSchedule = useCallback((method, schedule) => {
        const selectedPlan = _createPaymentPlanObject(method, schedule);
        const baseOfferingQuote = getBaseOfferingQuote(offeredQuotes, view.chosenQuote.value);
        const quoteDataForPlan = _findQuoteDataForPaymentPlan(baseOfferingQuote, selectedPlan, offeredQuotes, view.chosenQuote.value);
        if (quoteDataForPlan !== null) {
            setChosenQuoteData(quoteDataForPlan);
            view.chosenQuote.value = quoteDataForPlan.publicID;
            view.paymentDetails.downPaymentOverride_ML = offeredQuotesDownPaymentDetails_ML[offeredQuotes.indexOf(quoteDataForPlan)];
        }
        return quoteDataForPlan;
    }, [getBaseOfferingQuote, offeredQuotes, offeredQuotesDownPaymentDetails_ML, view.chosenQuote, view.paymentDetails]);

    const _getQuotesForSelectedPaymentMethod = useCallback((paymentMethod, nextCard) => {
        let installmentQuotePromise = null;
        let fullPayQuotePromise = null;
        const installmentPayPlan = _createPaymentPlanObject(paymentMethod, INSTALLMENT_SCHEDULE);
        const fullPayPlan = _createPaymentPlanObject(paymentMethod, FULL_PAY_SCHEDULE);
        if (paymentMethod !== MLRatingPaymentMethods.MORTGAGEE && !_isPaymentPlanQuoted(installmentPayPlan, offeredQuotes, chosenQuoteData)) {
            installmentQuotePromise = _quotePaymentPlan(submissionVM.sessionUUID.value, installmentPayPlan, chosenQuoteData, offeredQuotes);
        }
        onPaymentMethodChangedAlert(false);
        
        if (installmentQuotePromise !== null) {
            installmentQuotePromise.then((installmentQuote) => {
                updateHomeLosses(installmentQuote);
                offeredQuotes.push(installmentQuote.quote);
                offeredQuotesDownPaymentDetails_ML.push(installmentQuote.downPaymentOverride);
                if (chosenQuoteData.ratingPaymentSchedule_ML === INSTALLMENT_SCHEDULE) {
                    _updateChosenQuoteWithQuoteData(installmentQuote.quote);
                }
                if (paymentMethod !== MLRatingPaymentMethods.PAYROLL_DEDUCT && !_isPaymentPlanQuoted(fullPayPlan, offeredQuotes, chosenQuoteData)) {
                    fullPayQuotePromise = _quotePaymentPlan(submissionVM.sessionUUID.value, fullPayPlan, chosenQuoteData, offeredQuotes);
                }
                if (fullPayQuotePromise !== null) {
                    fullPayQuotePromise.then((fullPayQuote) => {
                        updateHomeLosses(fullPayQuote);
                        offeredQuotes.push(fullPayQuote.quote);
                        offeredQuotesDownPaymentDetails_ML.push(fullPayQuote.downPaymentOverride);
                        if (chosenQuoteData.ratingPaymentSchedule_ML === FULL_PAY_SCHEDULE) {
                            _updateChosenQuoteWithQuoteData(fullPayQuote.quote);
                        }
                        hideProgressDialog();
                        goToNextAccordion(nextCard);
                    });
                } else {
                    hideProgressDialog();
                    goToNextAccordion(nextCard);
                }
            }, (error) => {
                hideProgressDialog();
                console.error(error);
            });
        } else {
            if (paymentMethod !== MLRatingPaymentMethods.PAYROLL_DEDUCT
                && !_isPaymentPlanQuoted(fullPayPlan, offeredQuotes, chosenQuoteData, view.paymentDetails.firstYear_ML.value)) {
                fullPayQuotePromise = _quotePaymentPlan(submissionVM.sessionUUID.value, fullPayPlan, chosenQuoteData, offeredQuotes);
            }
            if (fullPayQuotePromise !== null) {
                fullPayQuotePromise.then((fullPayQuote) => {
                    updateHomeLosses(fullPayQuote);
                    offeredQuotes.push(fullPayQuote.quote);
                    offeredQuotesDownPaymentDetails_ML.push(fullPayQuote.downPaymentOverride);
                    if (chosenQuoteData.ratingPaymentSchedule_ML === FULL_PAY_SCHEDULE || isMortgageeSelected()) {
                        _updateChosenQuoteWithQuoteData(fullPayQuote.quote);
                    } else {
                        _updateChosenQuoteWithMethodAndSchedule(paymentMethod, INSTALLMENT_SCHEDULE);
                    }
                    hideProgressDialog();
                    goToNextAccordion(nextCard);
                }, () => {
                    hideProgressDialog();
                });
            } else {
                _updateChosenQuoteWithMethodAndSchedule(paymentMethod, chosenQuoteData.ratingPaymentSchedule_ML, view.paymentDetails.firstYear_ML.value);
                hideProgressDialog();
                goToNextAccordion(nextCard);
            }
        }
    }, [offeredQuotesDownPaymentDetails_ML, _quotePaymentPlan, _updateChosenQuoteWithMethodAndSchedule, _updateChosenQuoteWithQuoteData, chosenQuoteData, goToNextAccordion, isMortgageeSelected, offeredQuotes, submissionVM.sessionUUID.value, view.paymentDetails.firstYear_ML.value]);

    const updateQuoteDataAndGoToNextAccordion = useCallback((nextCard) => {
        showProgressDialog(platformMessages.saving);
        const paymentMethod = view.paymentDetails.ratingPaymentMethod_ML.value.code;
        // if (submissionVM.isBundle_ML) {
        //     MLBundleService.setPaymentDetailsForJob($scope.chosenQuoteData.quoteID, $scope.view.paymentDetails);
        // }
        view.paymentDetails.isInPaymentDetailsPage_ML = false;
        if (paymentMethod === MLRatingPaymentMethods.MORTGAGEE
            && orgSelectedMortgagePay !== view.paymentDetails.firstYear_ML.value) {
            setOrgSelectedMortgagePay(_.clone(view.paymentDetails.firstYear_ML.value));
            const updatePromise = LoadSaveService.updateQuotedSubmission(submissionVM.value, authHeader);
            updatePromise.then((data) => {
                submissionVM.quoteData.value = data.quoteData;
                setChosenQuoteData(getChosenQuoteDataFromQuotes(data.quoteData.offeredQuotes, view.chosenQuote.value));
                view.paymentDetails.downPaymentOverride_ML = data.bindData.paymentDetails.downPaymentOverride_ML;
                setEligibilityInfoChanged(false);
                view.paymentDetails.isInPaymentDetailsPage_ML = true;
                _getQuotesForSelectedPaymentMethod(paymentMethod, nextCard);
            },
                (error) => {
                    view.paymentDetails.isInPaymentDetailsPage_ML = true;
                    console.error(error);
                    hideProgressDialog();
                });
        } else {
            _getQuotesForSelectedPaymentMethod(paymentMethod, nextCard);
        }
    }, [_getQuotesForSelectedPaymentMethod, getChosenQuoteDataFromQuotes, orgSelectedMortgagePay, submissionVM.quoteData, submissionVM.value, view.chosenQuote.value, view.paymentDetails, authHeader]);

    const setHttpResponse = (instrumentType) => {
        let url = '';
        try {
            const frame = currentCard === ACCORDION_CARDS.DOWN_PAYMENT ? 'DownPaymentDetailsFrame' : 'PaymentDetailsFrame';
            url = document.getElementById(frame).contentWindow.location.href;
        } catch (error) {
            // do nothing - this is needed to prevent DOMException error message when jpmc iframe first loads
        }

        const params = _getUrlQueryParams(url);
        const token = params.token;

        if (params.DLAction === 'cancel') {
            _addPaymentusPaymentInstrument(currentCard, MLAccountPaymentMethods.CREDIT_CARD);
        } else if (params.DLAction === DL_ACTIONS.ADD_ACOUNT) {
            refreshPaymentInstruments().then((pmis) => {
                setPaymentInstruments(pmis);
                setPaymentDetailsUrl('');
                setDownPaymentDetailsUrl('');
                if (instrumentType === RECURRING_INSTRUMENT_TYPE) {
                    setRecurringPaymentInstrumentById(pmis, token);
                } else if (instrumentType === DOWNPAYMENT_INSTRUMENT_TYPE) {
                    setDownPaymentInstrumentById(pmis, token);
                    _storeNewlyAddedCreditCard(token);
                    _markCreditCardForDeletion(token);
                }
                refreshData();
            });
        } else if (params.DLAction === DL_ACTIONS.EDIT_ACCOUNT) {
            refreshPaymentInstruments().then((pmis) => {
                setPaymentInstruments(pmis);
            });
        }
    };

    //
    // initialization
    //
    const _initPaymentInstruments = useCallback(() => {
        const paymentInstrumentPromise = LoadSaveService.getPaymentInstruments(submissionVM.quoteID.value, submissionVM.sessionUUID.value, authHeader);
        showProgressDialog(platformMessages.loading, paymentInstrumentPromise);
        paymentInstrumentPromise.then((instruments) => {
            setPaymentInstruments(instruments);
            if (view.paymentDetails.selectedPaymentInstrument_ML.value) {
                setRecurringPaymentInstrumentById(instruments, view.paymentDetails.selectedPaymentInstrument_ML.value);
            }
        }, (err) => {
            console.error(err);
            setPaymentInstruments([]);
        });
    }, [setRecurringPaymentInstrumentById, submissionVM.quoteID.value, submissionVM.sessionUUID.value, view.paymentDetails.selectedPaymentInstrument_ML.value, authHeader]);

    const _initPaymentPlan = useCallback((paymentMethodCode) => {
        const isValidPaymentPlan = ((paymentPlanId, paymentPlans) => {
            return (paymentPlans.find((plan) => plan.publicID === paymentPlanId) !== undefined);
        });

        onPayThroughMortgageChange(paymentMethodCode === MLRatingPaymentMethods.MORTGAGEE);
        if (paymentMethodCode === MLRatingPaymentMethods.PAYROLL_DEDUCT) {
            selectPaymentPlan(MLPayrollDeductPlanPublicId);
        } else if (paymentMethodCode === MLRatingPaymentMethods.MORTGAGEE) {
            selectPaymentPlan(MLMortgageePayPlanPublicId);
        } else if (paymentMethodCode === MLRatingPaymentMethods.BANK_ACCOUNT || paymentMethodCode === MLRatingPaymentMethods.CREDIT_CARD) {
            view.paymentDetails.bankAccountDetails_ML.value = undefined;
            if (selectedScheduleFromQuotePage === FULL_PAY_SCHEDULE) {
                selectPaymentPlan(MLAnnuallyPayPlanPublicId);
            } else {
                selectPaymentPlan(MLMonthlyPayPlanPublicId);
            }
        } else if (paymentMethodCode === MLRatingPaymentMethods.PAY_ONLINE_OR_BY_MAIL) {
            if (selectedScheduleFromQuotePage === FULL_PAY_SCHEDULE) {
                selectPaymentPlan(MLAnnuallyPayPlanPublicId);
            } else if (chosenQuoteData && chosenQuoteData.termType_ML === 'Annual') {
                if (isValidPaymentPlan(MLMonthlyAnnualResponsivePlanPublicId, view.paymentPlans?.value)) {
                    selectPaymentPlan(MLMonthlyAnnualResponsivePlanPublicId);
                } else {
                    selectPaymentPlan(MLTwoPayAnnualPlanPublicId);
                }
            } else {
                if (isValidPaymentPlan(MLMonthlySemiAnnualResponsivePlanPublicId, view.paymentPlans?.value)) {
                    selectPaymentPlan(MLMonthlySemiAnnualResponsivePlanPublicId);
                } else {
                    selectPaymentPlan(MLTwoPaySemiAnnualPlanPublicId);
                }
            }
        } else {
            view.paymentDetails.selectedPaymentPlan_ML.value = undefined;
        }
        setPaymentChannel(paymentMethodCode);

        // $scope.$watch('view.paymentDetails.paymentChannel_ML.value', (newValue, oldValue) => {
        //     if (newValue !== oldValue) {
        //         if (submissionVM.isBundle_ML) {
        //             MLBundleService.setPaymentDetailsForJob($scope.chosenQuoteData.quoteID, $scope.view.paymentDetails);
        //         }
        //     }
        // });
    }, [chosenQuoteData, selectPaymentPlan, selectedScheduleFromQuotePage, onPayThroughMortgageChange, view.paymentDetails.bankAccountDetails_ML, view.paymentDetails.selectedPaymentPlan_ML]);

    const _initCurrentUser = useCallback(() => {
        if (gpaMode) {
            UserService.getCurrentUser(authHeader).then((user) => {
                setCurrentUser(user);
                view.paymentDetails.isPaymentChannelRequired_ML = gpaMode && user && (user.userType === MLUserTypes.PCS || user.userType === MLUserTypes.IA);
            });
        }
    }, [view.paymentDetails, authHeader]);

    const _openAppropriateAccordionSection = useCallback(() => {
        if (!_shouldHideGAFAccordion()) {
            goToSelectedAccordion(ACCORDION_CARDS.GROUP_DISCOUNT);
        } else {
            goToSelectedAccordion(ACCORDION_CARDS.PAYMENT_METHOD);
        }
    }, [_shouldHideGAFAccordion, goToSelectedAccordion, hidePaymentDetailsSection, isPayrollDeductionSelected, paymentInstruments, setPaymentInstrument, view.paymentDetails.selectedPaymentInstrument_ML.value]);

    const eligibilityCheckOnInitComplete = useCallback((isInitCheck) => {
        if (isInitCheck) {
            // re-check if the GAF accordion should be open
            const tempShouldHideGafAccordion = _shouldHideGAFAccordion();
            setHideGafAccorddion(tempShouldHideGafAccordion);
            if (!tempShouldHideGafAccordion) {
                goToSelectedAccordion(ACCORDION_CARDS.GROUP_DISCOUNT);
            } else {
                goToSelectedAccordion(ACCORDION_CARDS.PAYMENT_METHOD);
            }
        }
    }, [_shouldHideGAFAccordion, goToSelectedAccordion]);

    useEffect(() => {
        if (!isVMInitialised) {
            _initCurrentUser();
            submissionVM.quoteData.offeredQuotes.value.forEach(() => {
                offeredQuotesDownPaymentDetails_ML.push(submissionVM.bindData.paymentDetails.downPaymentOverride_ML.value);
                setOfferedQuotesDownPaymentDetails_ML(offeredQuotesDownPaymentDetails_ML);
            });
            // ctrl._setPaymentChannelOptions();
            setPaymentChannel(getRatingPaymentMethodCode());

            /* eslint-disable no-param-reassign */
            submissionVM.bindData.paymentDetails.value = submissionVM.bindData.paymentDetails.value || {};
            submissionVM.bindData.paymentDetails.downPaymentInstrument_ML.value = undefined;
            submissionVM.bindData.paymentDetails.customerPaymentMethod_ML.value = undefined;
            submissionVM.bindData.paymentDetails.isPaymentChannelRequired_ML = !isDownPaymentOverride();
            submissionVM.bindData.paymentDetails.isInPaymentDetailsPage_ML = true;
            submissionVM.bindData.paymentDetails.isAddBankAccount_ML = false;

            _initPaymentInstruments();

            setEligibilityInfoChangedAlert();
            _setDefaultPaymentMethod(_isMortgagePlanSelected(), isBankOptAvailable, view.paymentDetails.ratingPaymentMethod_ML.value.code);
            _initPaymentPlan(view.paymentDetails.ratingPaymentMethod_ML.value.code);
            // ctrl._initViewPrintButtonVisible();
            _openAppropriateAccordionSection();
            _setPayrollDeductFieldsAvailability();

            updateIsVMInitialised(true);
            if (gpaMode) {
                _getNewlyAddedCreditCards();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const editCard = useCallback((card) => {
        if (isComponentValid === false) {
            setShowErrors(true);
            setErrorTimestamp(errorTimestamp + 1);
        }

        if (!_.isUndefined(card)) {
            setCurrentCard(card);
        }
    }, [errorTimestamp, isComponentValid]);

    const onHeaderClicked = useCallback((card) => {
        editCard(card.name);
    }, [editCard]);

    // keep track of child component validation states
    const [childComponentStates] = useState({
        'employersAffiliationsComponent': true,
        'employersAffiliationsEligibilityComponent': true,
        'paymentMethodComponent': true,
        'paymentScheduleComponent': true,
        'recurringPaymentComponent': true,
        'downPaymentComponent': true
    });
    const onValidChildComponent = useCallback((isChildComponentValid, id) => {
        childComponentStates[id] = isChildComponentValid;
    }, [childComponentStates]);
    const isChildComponentValid = useCallback((id) => {
        return childComponentStates[id] === true;
    }, [childComponentStates]);

    const onNextCard = useCallback(({ card, nextCard }) => {
        const getChildComponent = () => {
            switch (card) {
                case ACCORDION_CARDS.GROUP_DISCOUNT:
                    return 'employersAffiliationsEligibilityComponent';
                case ACCORDION_CARDS.PAYMENT_METHOD:
                    return 'paymentMethodComponent';
                case ACCORDION_CARDS.PAYMENT_SCHEDULE:
                    return 'paymentScheduleComponent';
                case ACCORDION_CARDS.RECURRING_PAYMENT:
                    return 'recurringPaymentComponent';
                case ACCORDION_CARDS.DOWN_PAYMENT:
                    return 'downPaymentComponent';
                default:
                    return '';
            }
        };

        const isValidOtherPayment = () => {
            const isOtherPayorSelected_ML = _.get(submissionVM, 'value.bindData.paymentDetails.isOtherPayorSelected_ML', false);

            if (isOtherPayorSelected_ML) {
                const isOtherUpdated = _.get(submissionVM, 'value.bindData.paymentDetails.otherPayor_ML.updated', false);

                return isOtherUpdated
            }

            return true
        }
        const additionalInterests = submissionVM?.lobData?.homeowners?.coverables?.additionalInterests?.value;
        additionalInterests?.forEach((item) => {
            const contact = item?.policyAdditionalInterest;
            if (contact && contact?.policyBillingDocCommPref_Ext === 'email') {
                contact.policyBillingDocCommPref_Ext = undefined;
            }
        });
        
        const isCardComponentValid = isChildComponentValid(getChildComponent()) && isValidOtherPayment();        

        setShowErrors(isCardComponentValid === false);
        if (isCardComponentValid === false) {
            setErrorTimestamp(errorTimestamp + 1);
        }

        if (isCardComponentValid) {
            if (card === ACCORDION_CARDS.GROUP_DISCOUNT) {
                clearBlockAlerts('eligiblityRequired');
                clearBlockAlerts("ssnVerifyErr");
                clearBlockAlerts('last4SSNRequired');
                clearSpecificWarningAlert('altIdVerifError');

                if(qnbMode && !_.isEmpty(_.get(submissionVM, 'baseData.employeeInfo_ML.value.name')) && !_.get(submissionVM, 'baseData.gafInfo_ML.alternateIdUsage.value', false) && (_.isEmpty(_.get(submissionVM,'baseData.gafInfo_ML.last4SSN.value')) || _.get(submissionVM,'baseData.gafInfo_ML.last4SSN.value')?.length < 4)) {
                    addErrorAlert(messages.ssnValidation, 'last4SSNRequired');
                    setShowErrors(true);
                    setErrorTimestamp(errorTimestamp + 1);
                    return;
                }

                const isEFileVerificationNeededForPD = gafInfo?.eligibleForPayrollDeduct.value === ELIG_STATUS.ELIGIBLE_EFILE_VER_REQUIRED;
                const isEFileVerificationNeededForDB = gafInfo?.eligibleForDirectBill.value === ELIG_STATUS.ELIGIBLE_EFILE_VER_REQUIRED;
                const customerEligibilityFileInd  = gafInfo?.customerEligibilityFileIndicator?.value;
                const eligRequiredMsg = "Please complete the eligibility to continue!";
                
                if(!qnbMode && isPayrollDeductionSelected()) {
                    if(isEFileVerificationNeededForPD && customerEligibilityFileInd && _.isEmpty(_.get(submissionVM, 'baseData.employeeInfo_ML.value.name'))) {
                        addErrorAlert(eligRequiredMsg, 'eligiblityRequired');
                        setShowErrors(true);
                        setErrorTimestamp(errorTimestamp + 1);
                        return;
                    } 
                } else {
                    if (!qnbMode && isEFileVerificationNeededForDB && customerEligibilityFileInd && _.isEmpty(_.get(submissionVM, 'baseData.employeeInfo_ML.value.name'))) {
                        addErrorAlert(eligRequiredMsg, 'eligiblityRequired');
                        setShowErrors(true);
                        setErrorTimestamp(errorTimestamp + 1);
                        return;
                    } 
                }

                if(qnbMode && !_.isEmpty(_.get(submissionVM, 'baseData.gafInfo_ML.gpcCode.value'))) {
                    const newVm = viewModelService.clone(submissionVM);                  
                    _.set(newVm, 'baseData.gafInfo_ML.isQB.value', true);  
                    gafInfo.isQB.value = true; 

                    if(_.isEmpty(_.get(submissionVM, 'baseData.employeeInfo_ML.value.name')) && _.get(submissionVM, 'baseData.gafInfo_ML.alternateIdUsage.value', false)){
                        _.set(newVm, 'baseData.gafInfo_ML.alternateId', null); 
                        gafInfo.alternateId = null; 
                    }

                    updateWizardData(newVm);
                }

                updateGAFAndGoToNextAccordion(nextCard);
            } else if (card === ACCORDION_CARDS.PAYMENT_METHOD) {
                    if(gafInfo?.gpcCode) {
                        clearBlockAlerts('eligiblityRequired');

                const isEFileVerificationNeededForDB = gafInfo?.eligibleForDirectBill?.value === ELIG_STATUS.ELIGIBLE_EFILE_VER_REQUIRED;
                const customerEligibilityFileInd  = gafInfo?.customerEligibilityFileIndicator?.value;
                const eligRequiredMsg = "Please go to group affiliation/discount and complete the eligibility verification to continue!";

                    if(!qnbMode && !isPayrollDeductionSelected() && isEFileVerificationNeededForDB && customerEligibilityFileInd && _.isEmpty(_.get(submissionVM, 'baseData.employeeInfo_ML.value.name'))) {
                        addErrorAlert(eligRequiredMsg, 'eligiblityRequired');
                        setShowErrors(true);
                        setErrorTimestamp(errorTimestamp + 1);

                        return;
                    }
                }
                if (!(isPayByMortgageFirstYear() && isPCSAgent())) {
                    updateQuoteDataAndGoToNextAccordion(ACCORDION_CARDS.PAYMENT_SCHEDULE);
                } else {
                    updateQuoteDataAndGoToNextAccordion(ACCORDION_CARDS.RECURRING_PAYMENT);
                }
            } else if (card === ACCORDION_CARDS.PAYMENT_SCHEDULE) {
                if (!hidePaymentDetailsSection()) {
                    goToNextAccordion(ACCORDION_CARDS.RECURRING_PAYMENT);
                } else {
                    goToNextAccordion(ACCORDION_CARDS.DOWN_PAYMENT);
                }
            } else if (card === ACCORDION_CARDS.RECURRING_PAYMENT) {
                goToNextAccordion(ACCORDION_CARDS.DOWN_PAYMENT);
            } else {
                setCurrentCard(nextCard);
            }
        }
    }, [goToNextAccordion, hidePaymentDetailsSection, isChildComponentValid, isPCSAgent, isPayByMortgageFirstYear, updateGAFAndGoToNextAccordion, updateQuoteDataAndGoToNextAccordion, goToContactUsQnB]);

    useEffect(() => {
        if (!qnbMode) return;
        const paymentMethod = view.paymentDetails.paymentMethod.value;
 
        if ( paymentMethod && view.paymentDetails.downPaymentMethod_ML.value !== paymentMethod ) {
            view.paymentDetails.downPaymentMethod_ML.value = paymentMethod;
        }
    }, [qnbMode, view.paymentDetails.paymentMethod.value]);


    const onNextPage = useCallback(async () => {
        if (isGPA) {
            UserService.getCurrentUser(authHeader).then((user) => {
                if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                    HOTrackEvent('Issuance Step Submitted', false, submissionVM, user, { step: 'Payment Page', action: 'Payment Page Submitted' });
                }
                else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                    PUMBTrackEvent('Issuance Step Submitted', false, submissionVM, user, { step: 'Payment Page', action: 'Payment Page Submitted' });
                }
                else {
                    PATrackEvent('Issuance Step Submitted', false, submissionVM, user, { step: 'Payment Page', action: 'Payment Page Submitted' });
                }
            });
        } else {
            if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                    HOTrackEvent('Issuance Step Submitted', false, submissionVM, null, { step: 'Payment Page', action: 'Payment Page Submitted' }, true);
                } else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                    PUMBTrackEvent('Issuance Step Submitted', false, submissionVM, null, { step: 'Payment Page', action: 'Payment Page Submitted' }, true);
                } else {
                    PATrackEvent('Issuance Step Submitted', false, submissionVM, null, { step: 'Payment Page', action: 'Payment Page Submitted' }, true);
                }
        }

        if (isPayrollDeductionSelected()) {
            const isCardComponentValid = isChildComponentValid('paymentMethodComponent');
            if (isCardComponentValid === false) {
                setShowErrors(isCardComponentValid === false);
                setErrorTimestamp(errorTimestamp + 1);
                return false;
            }
        }

        if (isComponentValid === false) {
            setShowErrors(true);
            setErrorTimestamp(errorTimestamp + 1);
            return false;
        }

        showProgressDialog(platformMessages.saveSubmission);
        try {
            const response = await LoadSaveService.updateQuotedSubmission(submissionVM.value, authHeader);
            submissionVM.value = response;
            updateWizardData(submissionVM);
            if (!nextStepVisited()) {
                return submissionVM;
            }
            updateWizardSnapshot(submissionVM);
            goNext();
        } finally {
            hideProgressDialog(platformMessages.saveSubmission);
        }
        return false;
    }, [submissionVM, goNext, isComponentValid, authHeader]);

    const disableGroupDiscountButton = useCallback(() => {
        return !(gafInfo.aspects.valid && gafInfo.aspects.subtreeValid);
    }, [gafInfo]);

    const showPaymentMethodWizardPageActions = useCallback(() => {
        return isPayByMortgageFirstYear() || isPayrollDeductionSelected();
    }, [isPCSAgent, isPayByMortgageFirstYear, isPayrollDeductionSelected]);

    const disablePaymentMethodNextCardButton = useCallback(() => {
        if (isPayByMortgageFirstYear() && isPCSAgent()) {
            return isMortgageePartyMissing() || (
                isMortgageeSelected() && (
                    view.paymentDetails.firstYear_ML.value === null || _.isUndefined(view.paymentDetails.firstYear_ML.value)
                )
            );
        }
        return isMortgageePartyMissing() || getRatingPaymentMethodCode() === '';
    }, [getRatingPaymentMethodCode, isMortgageePartyMissing, isMortgageeSelected, isPCSAgent, isPayByMortgageFirstYear, view.paymentDetails.firstYear_ML.value]);

    const showPaymentScheduleWizardPageActions = useCallback(() => {
        return hideDownPaymentSection() && hidePaymentDetailsSection();
    }, [hideDownPaymentSection, hidePaymentDetailsSection]);

    const nextStepText_Ext = () => {
        return gpaMode ? (
            <FormattedMessage
                {...messages.ProceedAuthorizationSignature}
                values={{
                    AuthorizationSignature: (
                        <strong>{translator(messages.AuthorizationAndSignatures)}</strong>
                    )
                }}
            />
        ) : !qnbMode ?  (
            <FormattedMessage
                {...messages.ProcessYourPayment}
                values={{
                    YourPayment: (
                        <strong>{translator(messages.YourPayment)}</strong>
                    )
                }}
            />
        ) : null;
    };

    const isMakeDownPaymentButtonDisabled = () => {
        return !view.paymentDetails.downPaymentMethod_ML.value
            || (view.paymentDetails.downPaymentMethod_ML.value === 'agencysweep' && !view.paymentDetails.customerPaymentMethod_ML.value)
            || (view.paymentDetails.downPaymentMethod_ML.value !== 'agencysweep' && !isDownPaymentInstrumentSelected())
            || (view.paymentDetails.downPaymentMethod_ML.value === 'ach' && !view.paymentDetails.paymentChannel_ML.value)
            || (view.paymentDetails.downPaymentMethod_ML.value === 'creditcard' && !view.paymentDetails.downPaymentCreditCardExpDate_ML.value)
            || !_isReferralAgentsEligible()
            || showDownPaymentInstrumentError;
    };

    const getPaymentWizardPageActionsProps = useCallback((card) => {
        const isVisible = () => {
            if (card === ACCORDION_CARDS.PAYMENT_METHOD) {
                return showPaymentMethodWizardPageActions();
            }
            if (card === ACCORDION_CARDS.PAYMENT_SCHEDULE) {
                return showPaymentScheduleWizardPageActions();
            }
            if (card === ACCORDION_CARDS.RECURRING_PAYMENT) {
                return hideDownPaymentSection();
            }
            if (card === ACCORDION_CARDS.DOWN_PAYMENT) {
                return true;
            }
            return false;
        };

        const isDisabled = () => {
            if (card === ACCORDION_CARDS.PAYMENT_METHOD) {
                return isMortgageePartyMissing();
            }
            if (card === ACCORDION_CARDS.RECURRING_PAYMENT) {
                return isMakePaymentButtonDisabled();
            }
            if (card === ACCORDION_CARDS.DOWN_PAYMENT) {
                return isMakeDownPaymentButtonDisabled();
            }
            return false;
        };

        return {
            buttonText: gpaMode ? translator(messages.Continue) : translator(messages.MakePayment),
            message: nextStepText_Ext(),
            visible: isVisible(),
            disabled: isDisabled()
        };
    }, [_isReferralAgentsEligible, hideDownPaymentSection, isDownPaymentInstrumentSelected, isMakePaymentButtonDisabled, isMortgageePartyMissing, showPaymentMethodWizardPageActions, showPaymentScheduleWizardPageActions, translator, view.paymentDetails.customerPaymentMethod_ML.value, view.paymentDetails.downPaymentMethod_ML.value, view.paymentDetails.paymentChannel_ML.value]);

    const renderHeader = useCallback((active, card) => {
        const getAccordionNumber = () => {
            let number = 0;
            switch (card) {
                case ACCORDION_CARDS.PAYMENT_METHOD:
                    number += 1;
                    break;
                case ACCORDION_CARDS.PAYMENT_SCHEDULE:
                    number += 2;
                    break;
                case ACCORDION_CARDS.RECURRING_PAYMENT:
                    number += 3;
                    if (hidePaymentScheduleSection()) {
                        number -= 1;
                    }
                    break;
                case ACCORDION_CARDS.DOWN_PAYMENT:
                    number += 4;
                    if (hidePaymentScheduleSection()) {
                        number -= 1;
                    }
                    if (hidePaymentDetailsSection()) {
                        number -= 1;
                    }
                    break;
                default:
                    break;
            }
            if (hideGAFAccordion) {
                return number;
            }
            return number + 1;
        };

        const getAccordionCardTitle = () => {
            switch (card) {
                case ACCORDION_CARDS.GROUP_DISCOUNT:
                    return translator(messages.groupProgramEligibilityTitle);
                case ACCORDION_CARDS.PAYMENT_METHOD:
                    return translator(messages.paymentMethodTitle);
                case ACCORDION_CARDS.PAYMENT_SCHEDULE:
                    return translator(messages.paymentFrequencyTitle);
                case ACCORDION_CARDS.RECURRING_PAYMENT:
                    return translator(messages.recurringPaymentDetailsTitle);
                case ACCORDION_CARDS.DOWN_PAYMENT:
                    return translator(messages.downPaymentTitle);
                default:
                    return '';
            }
        };

        const showEditAction = () => {
            switch (card) {
                case ACCORDION_CARDS.GROUP_DISCOUNT:
                    return currentCard === ACCORDION_CARDS.PAYMENT_METHOD || currentCard === ACCORDION_CARDS.PAYMENT_SCHEDULE || currentCard === ACCORDION_CARDS.RECURRING_PAYMENT || currentCard === ACCORDION_CARDS.DOWN_PAYMENT;
                case ACCORDION_CARDS.PAYMENT_METHOD:
                    return currentCard === ACCORDION_CARDS.PAYMENT_SCHEDULE || currentCard === ACCORDION_CARDS.RECURRING_PAYMENT || currentCard === ACCORDION_CARDS.DOWN_PAYMENT;
                case ACCORDION_CARDS.PAYMENT_SCHEDULE:
                    return currentCard === ACCORDION_CARDS.RECURRING_PAYMENT || currentCard === ACCORDION_CARDS.DOWN_PAYMENT;
                case ACCORDION_CARDS.RECURRING_PAYMENT:
                    return currentCard === ACCORDION_CARDS.DOWN_PAYMENT;
                default:
                    return false;
            }
        };

        const _getDayWithOrdinalIndicator = (dayOfMonth = 0) => {
            if (dayOfMonth > 3 && dayOfMonth < 21) {
                return `${dayOfMonth}th`;
            }

            switch (dayOfMonth % 10) {
                case 1:
                    return `${dayOfMonth}st`;
                case 2:
                    return `${dayOfMonth}nd`;
                case 3:
                    return `${dayOfMonth}rd`;
                default:
                    return `${dayOfMonth}th`;
            }
        };

        const _getSelectedPaymentPlanName = (planValue) => {
            switch (planValue) {
                case MLMortgageePayPlanPublicId:
                    return translator(messages.Mortgage);
                case MLAnnuallyPayPlanPublicId:
                    return translator(messages.AnnualPayment);
                case MLMonthlyPayPlanPublicId:
                case MLMonthlyAnnualResponsivePlanPublicId:
                case MLMonthlySemiAnnualResponsivePlanPublicId:
                    return translator(messages.MonthlyPayment);
                case MLTwicePerMonthPayPlanPublicId:
                    return translator(messages.TwicePerMonth);
                case MLTwoPayAnnualPlanPublicId:
                case MLTwoPaySemiAnnualPlanPublicId:
                    return translator(messages.TwoPay);
                case MLFourPayAnnualPlanPublicId:
                    return translator(messages.FourPay);
                case MLPayrollDeductPlanPublicId:
                    return translator(messages.PayrollDeduct);
                default:
                    return '';
            }
        };

        const _secondPaymentDayOfMonth = (firstPaymentDayOfMonth) => {
            if (firstPaymentDayOfMonth >= 1 && firstPaymentDayOfMonth <= 15) {
                return firstPaymentDayOfMonth + 15;
            }

            return firstPaymentDayOfMonth - 15;
        };

        const showPaymentScheduleInfo = (selectedPaymentPlanML, paymentDayOfMonthML) => {
            let paymentDayOfMonthMLInt = paymentDayOfMonthML;
            if (!_.isNaN(parseInt(paymentDayOfMonthMLInt))) {
                paymentDayOfMonthMLInt = parseInt(paymentDayOfMonthML);
            };
            if (MLTwicePerMonthPayPlanPublicId === selectedPaymentPlanML) {
                return `${_getDayWithOrdinalIndicator(paymentDayOfMonthMLInt)} &
                ${_getDayWithOrdinalIndicator(_secondPaymentDayOfMonth(paymentDayOfMonthMLInt))}`;
            }

            return _getDayWithOrdinalIndicator(paymentDayOfMonthMLInt);
        };

        const getSubHeaderDescription = () => {
            switch (card) {
                case ACCORDION_CARDS.PAYMENT_METHOD:
                    return getPaymentMethodName(view.paymentDetails.ratingPaymentMethod_ML.value.code);
                case ACCORDION_CARDS.PAYMENT_SCHEDULE:
                    return translator(messages.PaymentScheduleSubHeader, {
                        paymentPlan: _getSelectedPaymentPlanName(view.paymentDetails.selectedPaymentPlan_ML.value),
                        paymentSchedule: showPaymentScheduleInfo(view.paymentDetails.selectedPaymentPlan_ML.value, view.paymentDetails.paymentDayOfMonth_ML.value)
                    });
                case ACCORDION_CARDS.RECURRING_PAYMENT:
                    if (!view.paymentDetails.nickname_ML.value) return '';
                    return translator(messages.PaymentDetailsSubHeader, {
                        nickname: view.paymentDetails.nickname_ML.value,
                        last4Digits: view.paymentDetails.last4Digits_ML.value
                    });
                default:
                    return '';
            }
        };

        const index = getAccordionNumber();
        return (
            <div className="ml-payment-header">
                <div className="ml-payment-header__main-content">
                    <span className={classNames('ml-count-icon ml-panel-set__item-indicator large static', { active: active })}>
                        {index}
                    </span>

                    <div className={qnbMode ? "ml-panel-set__item-titleQnB" : "ml-panel-set__item-title"}>
                        {getAccordionCardTitle()}
                    </div>

                    {gpaMode && showEditAction() && (
                        <button id={`edit${index}`} className={classNames('ml-panel-set__item-edit-cta', styles.gpaEditButton)}>
                            {translator(messages.Edit)}
                        </button>
                    )}

                    {!gpaMode && showEditAction() && (
                        <span className="edit-link">
                            <Link 
                                id={`edit${index}`} 
                                onClick={() => editCard(`${card}`)} 
                                aria-label={qnbMode ? `Edit ${getAccordionCardTitle()}`: ''}
                                role={qnbMode ? 'link' : 'button'}
                            >
                                {translator(messages.Edit)}
                            </Link>
                        </span>
                    )}
                </div>
                <div className="ml-payment-header__secondary-content">
                    {showEditAction() && (
                        <span className="ml-payment-header__secondary-content__sub-heading">
                            {getSubHeaderDescription()}
                        </span>
                    )}
                </div>
            </div>
        );
    }, [hideGAFAccordion, currentCard, editCard, getPaymentMethodName, hidePaymentDetailsSection, hidePaymentScheduleSection, translator, view.paymentDetails.last4Digits_ML.value, view.paymentDetails.nickname_ML.value, view.paymentDetails.paymentDayOfMonth_ML.value, view.paymentDetails.ratingPaymentMethod_ML.value.code, view.paymentDetails.selectedPaymentPlan_ML.value]);

    const onPrintApplication = () => {
        view.paymentDetails.isInPaymentDetailsPage_ML = false;
        let safariWindow;
        if (isSafariUser === true) {
            if (safariFile !== undefined) {
                const safariUrl = window.URL.createObjectURL(safariFile);
                safariWindow = window.open();
                safariWindow.location.href = safariUrl;
                view.paymentDetails.isInPaymentDetailsPage_ML = true;
            }
        } else {
            const saveAndQuotePromise = LoadSaveService.updateQuotedSubmission(submissionVM.value, authHeader);
            showProgressDialog(platformMessages.downloadingDocument);
            saveAndQuotePromise.then(() => {
                const formToPrint = _getFormToPrint();
                const getFormPromise = MLFormUtil.getFormDataForPayment(formToPrint, submissionVM, authHeader)
                getFormPromise.then((response) => {
                    MLFormUtil.saveFormAsFile(formToPrint, response, responseHeaders);
                    hideProgressDialog();
                }).catch((error) => {
                    hideProgressDialog();
                    if (safariWindow !== undefined) {
                        safariWindow.close();
                    }
                })
            }, () => {
                hideProgressDialog();
                // ModalService.showError(
                //     'ml.quoteandbind.common.util.MLFormUtil.Error',
                //     'ml.quoteandbind.common.util.MLFormUtil.We were unable to download your document, please try again.'
                // );
            }).finally(() => {
                view.paymentDetails.isInPaymentDetailsPage_ML = true;
            });
        }
    };

    if (!isVMInitialised) {
        return null;
    }

    const updateDownPaymentInstrument = (downPaymentMethod) => {
        view.paymentDetails.downPaymentMethod_ML.value = downPaymentMethod;
        view.paymentDetails.downPaymentInstrument_ML.value = undefined;
        view.paymentDetails.customerPaymentMethod_ML.value = undefined;
        const dpMethod = view.paymentDetails.downPaymentMethod_ML.value;
        const hasPaymentInstruments = hasPaymentInstrumentsForMethod(dpMethod);
        if (hasPaymentInstruments) {
            _defaultPaymentInstrument(paymentInstruments, DOWNPAYMENT_INSTRUMENT_TYPE, true);
        } else {
            if (dpMethod === MLAccountPaymentMethods.CREDIT_CARD ||
                (usePaymentusAch && dpMethod === MLAccountPaymentMethods.BANK_ACCOUNT)) {
                _addPaymentusPaymentInstrument(currentCard, dpMethod);
            } else if (!usePaymentusAch && dpMethod === MLAccountPaymentMethods.BANK_ACCOUNT) {
                _addBankAccountPaymentInstrument(DOWNPAYMENT_INSTRUMENT_TYPE);
            }
            setPaymentChannel(dpMethod);
        }
        refreshData();
    };

    const isAgencySweepOptionValid = () => {
        return gpaMode && _.get(submissionVM, 'producerCodeOfRecord_ML.agencySweepInfo_ML.agencySweepIndicator.value');
    };

    const getStickyComponentOverrideId = () => {
        if (!hideDownPaymentSection()) {
            return 'downPaymentWizardPageActions';
        }
        if (!hidePaymentDetailsSection()) {
            return 'recurringPaymentWizardPageActions';
        }
        if (!hidePaymentScheduleSection()) {
            return 'paymentScheduleWizardPageActions';
        }
        return 'paymentMethodWizardPageActions';
    };

    const getNextButtonDisabled = () => {
        if (!hideDownPaymentSection()) {
             return isMakeDownPaymentButtonDisabled();
        }
        if (!hidePaymentDetailsSection()) {
            return isMakePaymentButtonDisabled();
        }
        return isMortgageePartyMissing();
    };

    const resolvers = {
        resolveComponentMap: () => {
            // only assign one component to avoid validation issue since at most one card is visible
            switch (currentCard) {
                case ACCORDION_CARDS.GROUP_DISCOUNT:
                    return {
                        mlemployersaffiliationscomponent: MLEmployersAffiliationsComponent,
                        mlwizardpageactions: MLWizardPageActions
                    };
                case ACCORDION_CARDS.PAYMENT_METHOD:
                    return {
                        mlpaymentmethodcomponent: MLPaymentMethodComponent,
                        mlwizardpageactions: MLWizardPageActions
                    };
                case ACCORDION_CARDS.PAYMENT_SCHEDULE:
                    return {
                        mlpaymentschedulecomponent: MLPaymentScheduleComponent,
                        mlwizardpageactions: MLWizardPageActions
                    };
                case ACCORDION_CARDS.RECURRING_PAYMENT:
                    return {
                        mlrecurringpaymentcomponent: MLRecurringPaymentComponent,
                        mlwizardpageactions: MLWizardPageActions
                    };
                case ACCORDION_CARDS.DOWN_PAYMENT:
                    return {
                        mldownpaymentcomponent: MLDownPaymentComponent,
                        mlwizardpageactions: MLWizardPageActions
                    };
                default:
                    return {
                        mlwizardpageactions: MLWizardPageActions
                    };
            }
        },
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onNextCard,
            onNextPage,
            renderHeader,
            onHeaderClicked,
            onPrintApplication,
            onVerifyEligibility: () => { }
        }
    };

    const generateCardClasses = () => {
        const getClassName = (card) => {
            if (card === currentCard) {
                return card === ACCORDION_CARDS.GROUP_DISCOUNT ? 'ml-panel-set__item active padding-top-0' : 'ml-panel-set__item active';
            }
            return card === ACCORDION_CARDS.GROUP_DISCOUNT ? 'ml-panel-set__item padding-top-0' : 'ml-panel-set__item';
        };
        const getCardVisible = (card) => {
            switch (card) {
                case ACCORDION_CARDS.GROUP_DISCOUNT:
                    return !hideGAFAccordion;
                case ACCORDION_CARDS.PAYMENT_SCHEDULE:
                    return !hidePaymentScheduleSection();
                case ACCORDION_CARDS.RECURRING_PAYMENT:
                    return !hidePaymentDetailsSection();
                case ACCORDION_CARDS.DOWN_PAYMENT:
                    return !hideDownPaymentSection();
                default:
                    return true;
            }
        };

        const getIsCollapsible = (card) => {
            switch (card) {
                case ACCORDION_CARDS.GROUP_DISCOUNT:
                    return currentCard === ACCORDION_CARDS.PAYMENT_METHOD || ACCORDION_CARDS.PAYMENT_SCHEDULE || currentCard === ACCORDION_CARDS.RECURRING_PAYMENT || currentCard === ACCORDION_CARDS.DOWN_PAYMENT;
                case ACCORDION_CARDS.PAYMENT_METHOD:
                    return currentCard === ACCORDION_CARDS.PAYMENT_SCHEDULE || currentCard === ACCORDION_CARDS.RECURRING_PAYMENT || currentCard === ACCORDION_CARDS.DOWN_PAYMENT;
                case ACCORDION_CARDS.PAYMENT_SCHEDULE:
                    return currentCard === ACCORDION_CARDS.RECURRING_PAYMENT || currentCard === ACCORDION_CARDS.DOWN_PAYMENT;
                case ACCORDION_CARDS.RECURRING_PAYMENT:
                    return currentCard === ACCORDION_CARDS.DOWN_PAYMENT;
                case ACCORDION_CARDS.DOWN_PAYMENT:
                    return false;
                default:
                    return true;
            }
        };

        const overrides = Object.values(ACCORDION_CARDS).map((value) => {
            return {
                [`${value}`]: {
                    className: getClassName(value),
                    visible: getCardVisible(value),
                    isCollapsible: getIsCollapsible(value)
                }
            };
        });

        return Object.assign({}, ...overrides);
    };


    const reQuoteWhenUpdatingPayment = (payment) => {

        let quotePromise = null;

        const paymentMethod = payment.code;

        const installmentPayPlan = _createPaymentPlanObject(paymentMethod, INSTALLMENT_SCHEDULE);
        const fullPayPlan = _createPaymentPlanObject(paymentMethod, FULL_PAY_SCHEDULE);

        let updateFrequencyDetails = null;

        if(paymentMethod === MLRatingPaymentMethods.PAYROLL_DEDUCT){
            updateFrequencyDetails = installmentPayPlan;
        }else if(payment.code === MLRatingPaymentMethods.MORTGAGEE || chosenQuoteData.ratingPaymentSchedule_ML === FULL_PAY_SCHEDULE) {
            updateFrequencyDetails = fullPayPlan
        } else if(chosenQuoteData.ratingPaymentSchedule_ML === INSTALLMENT_SCHEDULE) {
            updateFrequencyDetails = installmentPayPlan        
        }

        const isPayplanAvailable = !_isPaymentPlanQuoted(updateFrequencyDetails, offeredQuotes, chosenQuoteData, view.paymentDetails.firstYear_ML.value)
 
        if(updateFrequencyDetails && isPayplanAvailable){
           quotePromise = _quotePaymentPlan(submissionVM.sessionUUID.value, updateFrequencyDetails, chosenQuoteData, offeredQuotes);
        } else {
            _updateChosenQuoteWithMethodAndSchedule(updateFrequencyDetails.ratingPaymentMethod_ML, updateFrequencyDetails.ratingPaymentSchedule_ML, view.paymentDetails.firstYear_ML.value);
        }
        
        if (quotePromise !== null) {
            showProgressDialog(platformMessages.saving);
            quotePromise.then((createdQuote) => {
                updateHomeLosses(createdQuote);
                offeredQuotes.push(createdQuote.quote);
                offeredQuotesDownPaymentDetails_ML.push(createdQuote.downPaymentOverride);
                _updateChosenQuoteWithQuoteData(createdQuote.quote);
                hideProgressDialog();

             })
        }
    }

    const overrides = {
        printApplication: {
            visible: isViewPrintButtonVisible()
        },
        accordionContainer: {
            accordionStates: [currentCard]
        },
        groupDiscountDescription: {
            className: qnbMode ? "ml-panel-set__item-descriptionqb mobileWidthQB" : "ml-panel-set__item-description"
        },
        groupDiscountContent: {
            className: qnbMode ? "ml-panel-set__item-contentqb mobileWidthQBContent" : "ml-panel-set__item-content"
        },
        groupDiscountOptions: {
            value: showGroupDiscountSection.toString(),
            visible: qnbMode ? false : true,
            onValueChange: (value) => {
                if (value !== showGroupDiscountSection) {
                    setGafRadioSelectionChanged(true);
                    setShowGroupDiscountSection(value);
                    if (getRatingPaymentMethodCode() === MLRatingPaymentMethods.PAYROLL_DEDUCT) {
                        _setDefaultPaymentMethod(false, false, undefined);
                    }
                }
            }
        },
        paymentMethodComponent: {
            submissionVM,
            updateWizardData,
            setShowErrors,
            onValidate: onValidChildComponent,
            showValidationErrors: showErrors,
            paymentInstruments,
            paymentDetails: view.paymentDetails,
            gafInfoObject: {
                gafInfo: gafInfo,
                choseEligibility: showGroupDiscountSection
            },
            hasSsn,
            hasDepartmentNumber,
            hasEmployeeNumber,
            hasMetroBadgeNumber,
            gpaMode,
            qnbMode,
            periodStartDate: submissionVM.baseData.periodStartDate.value,
            productCode: submissionVM.baseData.productCode,
            coveragePartType: submissionVM?.lobData?.homeowners?.coverables?.coveragePartType_ML?.value?.code || '',
            premium: _.get(chosenQuoteData, 'premium.total'),
            paymentPlans: _.get(chosenQuoteData, 'paymentPlans_ML', []),
            hasMortgagees: hasMortgageesOnSubmission(),
            isEndorsement: false,
            isCitrixSecureEnv,
            currentUser,
            onRatingPaymentMethodChange: (value) => {
                onPaymentMethodChangedAlert(true);
                setPaymentMethod(value.code);
                _initPaymentPlan(value.code);
                reQuoteWhenUpdatingPayment(value);
                // disregardFieldValidation('paymentMethodComponent');
                 if (qnbMode) {
                    updateWizardData(submissionVM);
                 }
                refreshData();
            },
            selectPaymentPlan,
            refreshPaymentPage: refreshData,
            steps,
            jumpTo,
            visible: currentCard === ACCORDION_CARDS.PAYMENT_METHOD
        },
        paymentScheduleComponent: {
            onValidate: onValidChildComponent,
            showValidationErrors: showErrors,
            paymentDetails: view.paymentDetails,
            isEndorsement: false,
            offeredQuotes,
            chosenQuote: view.chosenQuote,
            termType: chosenQuoteData ? chosenQuoteData.termType_ML : '',
            gpaMode,
            selectPaymentPlan,
            visible: currentCard === ACCORDION_CARDS.PAYMENT_SCHEDULE,
            periodStartDate: submissionVM.baseData.periodStartDate,
            selectPreferredPaymentMethodInd,
            isModernProduct,
             qnbMode,
             updateWizardData,
             submissionVM
        },
        paymentScheduleContent: {
            className : qnbMode ? "accordionContents" : "ml-panel-set__item-content"
        },
        paymentMethodContent: {
            className : qnbMode ? "accordionContents" : "ml-panel-set__item-content"
        },
        recurringPaymentContent: {
            className : qnbMode ? "accordionContents" : "ml-panel-set__item-content"
        },
        recurringPaymentComponent: {
            onValidate: onValidChildComponent,
            showValidationErrors: showErrors,
            paymentDetails: view.paymentDetails,
            paymentInstruments,
            onPaymentInstrumentChange: onRecurringPaymentInstrumentChange,
            addRecurringPaymentInstrument,
            canShowCreditCard,
            isCreditDebitSelected,
            isBankAccountSelected,
            hasPaymentInstrumentsForMethod,
            saveNewBankAccountPaymentInstrument,
            setHttpResponse,
            paymentDetailsUrl,
            canRemovePaymentInstrument,
            editPaymentInstrument,
            deletePaymentInstrument,
            allowAlternatePayor,
            quoteNumber: submissionVM.quoteID.value,
            referralAgents: referralValues || view.referralAgents_ML.value || [],
            saveReferralAgentProducer,
            commissionOptions,
            setHasReferralAgentSelected,
            setIsReferralAgentValid,
            isGcsSalesAgent,
            isSplUser,
            setErrorTimestamp,
            errorTimestamp,
            visible: currentCard === ACCORDION_CARDS.RECURRING_PAYMENT,
            usePaymentusAch,
            showRecurringPaymentInstrumentError
        },
        downPaymentComponent: {
            onValidate: onValidChildComponent,
            showValidationErrors: showErrors,
            currentUser,
            paymentDetails: view.paymentDetails,
            paymentInstruments,
            chosenQuoteData,
            gpaMode,
            qnbMode,
            submissionVM,
            onPaymentInstrumentChange: onDownPaymentInstrumentChange,
            updateDownPaymentInstrument,
            refreshData,
            isShowAgentPaymentChannel,
            addDownPaymentInstrument,
            isPayOnlineOrMailSelected,
            canShowCreditCard,
            hasPaymentInstrumentsForMethod,
            saveNewBankAccountPaymentInstrument,
            setHttpResponse,
            downPaymentDetailsUrl,
            canRemovePaymentInstrument,
            editPaymentInstrument,
            deletePaymentInstrument,
            setDownPaymentMethod,
            setErrorTimestamp,
            errorTimestamp,
            visible: currentCard === ACCORDION_CARDS.DOWN_PAYMENT,
            isAgencySweepOptionValid,
            isSplUser,
            usePaymentusAch,
            showDownPaymentInstrumentError
        },
        paymentMethodNextCardButton: {
            visible: !showPaymentMethodWizardPageActions(),
            disabled: disablePaymentMethodNextCardButton(),
            className: qnbMode ? "primaryButton" : ""
        },
        paymentMethodWizardPageActions: getPaymentWizardPageActionsProps(ACCORDION_CARDS.PAYMENT_METHOD),
        paymentScheduleNextCardButton: {
            visible: !showPaymentScheduleWizardPageActions(),
            className: qnbMode ? "primaryButton" : ""
        },
        paymentScheduleWizardPageActions: getPaymentWizardPageActionsProps(ACCORDION_CARDS.PAYMENT_SCHEDULE),
        recurringPaymentNextCardButton: {
            visible: !hideDownPaymentSection(),
            disabled: isMakePaymentButtonDisabled() || (commissionOptions.isReferralAgentSelected && !isReferralAgentValid),
            className: qnbMode ? "primaryButton" : ""
        },
        recurringPaymentWizardPageActions: getPaymentWizardPageActionsProps(ACCORDION_CARDS.RECURRING_PAYMENT),
        downPaymentWizardPageActions: getPaymentWizardPageActionsProps(ACCORDION_CARDS.DOWN_PAYMENT),
        employersAffiliationsComponent: {
            onValidate: onValidChildComponent,
            visible: showGroupDiscountSection,
            model: submissionVM,
            updateWizardData,
            isPaymentScreen: true,
            setDisableNextButton,
            showErrors,
            eligibilityCheckOnInitComplete,
            isModernProduct: isModernProduct
        },
        groupDiscountButton: {
            disabled: disableNextButton,
            className: qnbMode ? "primaryButton" : ""
        },
        ...generateCardClasses()
    };


    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            skipWhen={skipOnResumeIf}
            showNext={!nextStepVisited()}
            onNext={onNextPage}
            disableNext={getNextButtonDisabled()}
            showTextNextToButton={!nextStepVisited()}
            nextLabel={translator(gpaMode ? messages.Continue : (qnbMode && isPayrollDeductionSelected()) ? messages.Next : messages.MakePayment)}
            textNextToButton={nextStepText_Ext()}
            metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
            stickyComponentOverrideId={getStickyComponentOverrideId()}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                model={submissionVM}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                showErrors={showErrors}
                componentMap={resolvers.resolveComponentMap()}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
};

PaymentPage.propTypes = wizardProps;
export default withRouter(PaymentPage);
